module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SmartSignPop = undefined;

	var _SignPop = __webpack_require__(1);

	var _SignPop2 = _interopRequireDefault(_SignPop);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.SmartSignPop = _SignPop2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _config = __webpack_require__(3);

	var _config2 = _interopRequireDefault(_config);

	var _Constants = __webpack_require__(4);

	var _Constants2 = _interopRequireDefault(_Constants);

	var _utils = __webpack_require__(5);

	var _utils2 = _interopRequireDefault(_utils);

	var _fetchJsonp = __webpack_require__(6);

	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

	var _componentCookie = __webpack_require__(7);

	var _componentCookie2 = _interopRequireDefault(_componentCookie);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var loginUtils = __webpack_require__(12); /**
	                                                 * Created by mac on 16/8/10.
	                                                 */


	//导入组件
	var SignInPop = __webpack_require__(14);
	var SignUpPop = __webpack_require__(21);

	var SmartSignPop = _react2.default.createClass({
	  displayName: 'SmartSignPop',

	  propTypes: function propTypes() {
	    return {
	      popType: _react2.default.PropTypes.string,
	      from: _react2.default.PropTypes.string,
	      group: _react2.default.PropTypes.string,
	      smartUrl: _react2.default.PropTypes.string,
	      source: _react2.default.PropTypes.string,
	      userCenterApi: _react2.default.PropTypes.string, //后台接口api
	      card: _react2.default.PropTypes.string, //代金券api
	      closePop: _react2.default.PropTypes.func,
	      detail: _react2.default.PropTypes.string,
	      signSuccessCallback: _react2.default.PropTypes.func //登录成功后的callback
	    };
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      popType: 0,
	      from: 'pc',
	      group: 'C',
	      smartUrl: 'www.smartstudy.com/',
	      source: 'www.smartstudy.com',
	      userCenterApi: _config2.default.api.userCenterApi,
	      card: _config2.default.api.card,
	      closePop: function closePop() {
	        console.log('关闭弹框');
	      },
	      detail: '',

	      signSuccessCallback: function signSuccessCallback() {
	        console.log('登录成功后的回调函数');
	        var Redirect = location.href.split('#')[0];
	        location.href = Redirect;
	      }
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      loginPop: 0 // 除了0，1，2，3的默认值
	    };
	  },

	  render: function render() {
	    var tmpLogin = this.props.popType && !this.state.loginPop ? this.props.popType : this.props.popType && this.state.loginPop ? this.state.loginPop : 0;
	    switch (tmpLogin) {
	      case 1:
	        return _react2.default.createElement(SignInPop, {
	          login: tmpLogin,
	          from: this.props.from,
	          group: this.props.group,
	          smart: this.props.smartUrl,
	          closePop: this.closePop,
	          userCenterApi: this.props.userCenterApi,
	          openSignUpEmail: this.openSignUpEmail,
	          openSignUp: this.openSignUp,
	          signSuccessCallback: this.props.signSuccessCallback

	        });
	      case 2:
	      case 3:
	        return _react2.default.createElement(SignUpPop, {
	          login: tmpLogin,
	          from: this.props.from,
	          group: this.props.group,
	          smart: this.props.smartUrl,
	          source: this.props.source,
	          userCenterApi: this.props.userCenterApi,
	          card: this.props.card,
	          closePop: this.closePop,
	          openSignUpEmail: this.openSignUpEmail,
	          openSignUp: this.openSignUp,
	          openSignIn: this.openSignIn,
	          detail: this.props.detail
	        });
	      default:
	        return _react2.default.createElement('div', null);
	    }
	  },

	  //关闭弹窗
	  closePop: function closePop() {
	    this.setState({
	      loginPop: 0
	    });

	    this.props.closePop();
	  },

	  //邮箱注册
	  openSignUpEmail: function openSignUpEmail() {
	    this.setState({
	      loginPop: 3
	    });
	  },

	  //手机注册
	  openSignUp: function openSignUp() {
	    this.setState({
	      loginPop: 2
	    });
	  },

	  //登录
	  openSignIn: function openSignIn() {
	    this.setState({
	      loginPop: 1
	    });
	  }
	});

	//为了暴露一些方法  直接外部调用

	//SmartSignPop.openSignInPop = function (login, from, group, smart, source, userCenterApi, card, closePop) {
	//  let div = document.createElement('div');
	//  document.body.appendChild(div);
	//  var tmpLogin = login && !this.state.loginPop ? login
	//    : login && this.state.loginPop ? this.state.loginPop
	//    : 0;
	//  ReactDOM.render(
	//    <Login
	//      login={tmpLogin}
	//      from={from}
	//      group={group}
	//      smart={smart}
	//      source={source}
	//      userCenterApi={userCenterApi}
	//      card={card}
	//      closePop={closePop}
	//      openSignUpEmail={this.openSignUpEmail}
	//      openSignUp={this.openSignUp}
	//      openSignIn={this.openSignIn}
	//      />, div);
	//};

	module.exports = SmartSignPop;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  env: 'production',

	  // 后台接口（绝对地址）
	  api: {
	    userCenterApi: '', //未上线
	    card: ''
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Created by xieshanshan on 16/8/6.
	 */

	module.exports = {
	  THIRD_LOGIN: {
	    WEIXIN: 'weixin',
	    WEIBO: 'weibo',
	    QQ: 'qq',
	    BAIDU: 'baidu'
	  },

	  LOGIN_TEXT: {
	    SIGN_IN_TITLE: '登录',
	    SIGN_IN_BTN: '登录',
	    SIGN_IN_TEXT: '立即注册',
	    SIGN_UP_TITLE: '注册',
	    SIGN_UP_BTN: '注册',
	    SIGN_UP_TEXT: '立即登录'
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  changeColor: function changeColor(skills, index) {
	    switch (index) {
	      case 0:
	        return '#34cc99';
	      case 1:
	        return '#1aa9e5';
	      case 2:
	        return '#f66e80';
	      case 3:
	        if (skills.length === 4) {
	          return '#fbae55';
	        }
	        return '#fa8b68';
	      case 4:
	        return '#fbae55';
	      default:
	        return '#34cc99';
	    }
	  },

	  routerParams: function routerParams(params) {
	    var ary = this.transformObjToAry(params);
	    if (ary && ary.length) {
	      var val = params[ary[ary.length - 1]];
	      if (val.substring(val.length - 5, val.length) === '.html') {
	        val = val.substring(0, val.length - 5);
	      }
	      params[ary[ary.length - 1]] = val;
	    }
	    return params;
	  },

	  transformObjToAry: function transformObjToAry(obj) {
	    var arr = [];
	    for (var item in obj) {
	      arr.push(item);
	    }
	    return arr;
	  },
	  /* eslint-disable */
	  doyooAccess: function doyooAccess() {
	    console.log('--------');
	    if (typeof window === 'undefined') return;
	    if (window && window.zk_show_looyu) {
	      window.zk_show_looyu();
	    }
	    console.log('========');
	  },

	  isArray: function isArray(value) {
	    return value.isArray || toString.call(value) === '[object Array]';
	  },

	  /**
	   * 获取元素坐标值
	   * @param e
	   * @returns {{x: (number|Number), y: (number|Number)}}
	   */
	  getAbsPoint: function getAbsPoint(e) {
	    var x = e.offsetLeft;
	    var y = e.offsetTop;
	    var h = e.offsetHeight;
	    var w = e.offsetWidth;
	    while (e = e.offsetParent) {
	      x += e.offsetLeft;
	      y += e.offsetTop;
	    }
	    return { 'x': x, 'y': y, 'w': w, 'h': h };
	  },

	  limitStr: function limitStr(value, num) {
	    var objString = value.replace(/&nbsp;/ig, '#');
	    var objLength = objString.length;
	    if (objLength > num) {
	      objString = objString.substring(0, num).replace(/#/g, '&nbsp;') + '...';
	    }
	    return objString;
	  },
	  /* eslint-enable */
	  addAmountKey: function addAmountKey(ary) {
	    for (var i = 0; i < ary.length; i++) {
	      ary[i]['amount'] = 0;
	    }
	    return ary;
	  },

	  objToAry: function objToAry(arrayObj, param) {
	    var ary = [];
	    for (var i = 0; i < arrayObj.length; i++) {
	      ary.push(arrayObj[i][param]);
	    }
	    return ary;
	  },

	  addCorrectItems: function addCorrectItems(correction, newCorrection, del) {
	    newCorrection['amount'] = Number(newCorrection.amount);
	    if (correction.length) {
	      var newNum = 0;
	      for (var i = 0; i < correction.length; i++) {
	        if (correction[i].id === newCorrection.id) {
	          if (del === 'del') {
	            if (!newCorrection.amount) {
	              var slice1 = correction.slice(0, i);
	              var slice2 = correction.slice(i + 1, correction.length);
	              correction = slice1.concat(slice2);
	            } else {
	              correction[i].amount = newCorrection.amount;
	            }
	          } else {
	            correction[i].amount = newCorrection.amount;
	          }
	        } else if (correction[i].id !== newCorrection.id) {
	          newNum++;
	        }
	      }

	      if (newNum === correction.length && newCorrection.amount) {
	        correction.push(newCorrection);
	      }

	      return correction;
	    } else if (!correction.length && newCorrection.amount) {
	      return [newCorrection];
	    } else {
	      return correction;
	    }
	  },

	  correctPriceTotal: function correctPriceTotal(correction) {
	    var priceTotal = 0;
	    if (correction.length) {
	      for (var i = 0; i < correction.length; i++) {
	        priceTotal += Number(correction[i].price) * Number(correction[i].amount);
	      }
	    }
	    return priceTotal;
	  },

	  correctCntPriceTotal: function correctCntPriceTotal(correction) {
	    var cntPriceTotal = 0;
	    if (correction.length) {
	      for (var i = 0; i < correction.length; i++) {
	        cntPriceTotal += Number(correction[i].cntPrice) * Number(correction[i].amount);
	      }
	    }
	    return cntPriceTotal;
	  },

	  verifyNumber: function verifyNumber(value) {
	    var myreg = /^\+?[1-9][0-9]*$/;
	    return myreg.test(value);
	  },

	  verifyEmail: function verifyEmail(value) {
	    //对电子邮件的验证f
	    var email = value.replace(/(^\s+)|(\s+$)/g, "");
	    var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
	    return myreg.test(email);
	  },

	  verifyPhone: function verifyPhone(value) {
	    var phone = value.replace(/(^\s+)|(\s+$)/g, "");
	    return (/^0?1[3|4|5|7|8][0-9]\d{8}$/.test(phone)
	    );
	  },

	  verifySharp: function verifySharp(value) {
	    return value.indexOf("#") != -1;
	  },

	  verifyPassword: function verifyPassword(value) {
	    return value.length > 6 || value.length == 6;
	  },

	  verifyNickname: function verifyNickname(value) {
	    return value.length > 15;
	  },

	  //去邮箱验证的
	  goEmailUrl: function goEmailUrl(type) {
	    var emailArray = {
	      'qq': '//mail.qq.com',
	      '163': '//mail.163.com',
	      '126': '//mail.126.com',
	      'yeah': '//www.yeah.net',
	      'yahoo': '//login.yahoo.com/',
	      'sina': '//mail.sina.com.cn',
	      'hotmail': '//login.live.com',
	      'aliyun': '//mail.aliyun.com',
	      'gmail': '//gmail.google.com',
	      'sohu': '//mail.sohu.com',
	      'outlook': '//login.live.com',
	      'icloud': '//www.icloud.com'
	    };
	    if (emailArray[type]) {
	      return emailArray[type];
	    } else {
	      return false;
	    }
	  },

	  //new Date 转换成年月日
	  getDays: function getDays(newDate) {
	    var newDate = new Date();
	    var year = newDate.getFullYear(); //获得年份
	    var month = newDate.getMonth() + 1; //此方法获得的月份是从0---11，所以要加1才是当前月份
	    var day = newDate.getDate(); //获得当前日期
	    var days = year + '-' + month + '-' + day;
	    return days;
	  },
	  //求两个日期间相差的天数
	  abDays: function abDays(time1, time2) {
	    //传递的时间是2016-08-08
	    var aDate, oDate1, oDate2, numDay;
	    aDate = time1.split("-");
	    oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]); //转换为08-08-2016格式
	    aDate = time2.split("-");
	    oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]);
	    numDay = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) + 1; //把相差的毫秒数转换为天数
	    return numDay;
	  },

	  // Simplified from jQuery.params()
	  // Need to Improve
	  objUrlEncode: function objUrlEncode(object) {
	    var r20 = /%20/g;
	    var stringArr = [];

	    for (var key in object) {
	      var value = object[key] === null ? '' : object[key];
	      stringArr.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	    }

	    return stringArr.join('&').replace(r20, '+');
	  },

	  showTime: function showTime(second) {
	    var now = new Date().getTime();
	    var minusTime = Math.round((now - second) / 1000);
	    if (minusTime < 60) {
	      return minusTime + '秒前';
	    } else if (minusTime < 60 * 60) {
	      return Math.round(minusTime / 60) + '分钟前';
	    } else if (minusTime < 60 * 60 * 24) {
	      return Math.round(minusTime / (60 * 60)) + '小时前';
	    } else if (minusTime < 60 * 60 * 24 * 3) {
	      return Math.round(minusTime / (60 * 60 * 24)) + '天前';
	    } else {
	      return this.dateFormat(new Date(second), 'yyyy-MM-dd hh:mm:ss');
	    }
	  },

	  dateFormat: function dateFormat(date, fmt) {
	    var o = {
	      'M+': date.getMonth() + 1, //月份
	      'd+': date.getDate(), //日
	      'h+': date.getHours(), //小时
	      'm+': date.getMinutes(), //分
	      's+': date.getSeconds(), //秒
	      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
	      'S': date.getMilliseconds() //毫秒
	    };
	    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	    for (var k in o) {
	      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
	    }return fmt;
	  },
	  // 数字转时间
	  // From smartstudy-frontend/src/scripts/play/player.js
	  int2Time: function int2Time(num) {
	    num = num || 0;
	    var time = '';
	    num = parseInt(num);
	    time = num % 60 < 10 ? '0' + num % 60 : num % 60;
	    num = parseInt(num / 60);
	    time = (num % 60 < 10 ? '0' + num % 60 : num % 60) + ':' + time;
	    num = parseInt(num / 60);
	    time = (num % 60 < 10 ? '0' + num % 60 : num % 60) + ':' + time;
	    return time;
	  },

	  // 时间转数字
	  // From smartstudy-frontend/src/scripts/play/player.js
	  time2Int: function time2Int(time) {
	    time = time.split(':');
	    return parseInt(time[0]) * 3600 + parseInt(time[1]) * 60 + parseInt(time[2]);
	  },

	  /**
	   * 数字转时间
	   * @param totalTime
	   * @returns {string|*}
	   */
	  timeFormate: function timeFormate(totalTime) {
	    var day = 0,
	        hour = 0,
	        minute = 0,
	        seconds = 0;
	    if (totalTime > 0) {
	      day = Math.floor(totalTime / (60 * 60 * 24));
	      hour = Math.floor(totalTime / (60 * 60)) - day * 24;
	      minute = Math.floor(totalTime / 60) - day * 24 * 60 - hour * 60;
	      seconds = Math.floor(totalTime) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60;
	    }
	    if (hour <= 9) hour = '0' + hour;
	    if (minute <= 9) minute = '0' + minute;
	    if (seconds <= 9) seconds = '0' + seconds;

	    if (hour === '00') {
	      totalTime = minute + ':' + seconds;
	    } else {
	      totalTime = hour + ':' + minute + ':' + seconds;
	    }

	    return totalTime;
	  },

	  /**
	   * 回到页面顶部
	   *
	   */
	  gotoTop: function gotoTop() {
	    if (typeof window === 'undefined') return;
	    if (window && window.scrollTo) {
	      window.scrollTo(0, 0);
	    }
	    // window.parent.scrollTo(0, 0);
	  },
	  openWin: function openWin(url, target) {
	    try {
	      var div = document.createElement(div);
	      //var divId='download_'+parseInt(Math.random()*10000);
	      //div.id = divId;
	      div.innerHTML = '<a href="' + url + '" target="' + (target || _self) + '"></a>';
	      //document.body.appendChild(div);
	      div.firstChild.click();
	    } catch (ex) {
	      throw 'open error!';
	    } finally {
	      div = null;
	    }
	  }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	    factory(exports, module);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, mod);
	    global.fetchJsonp = mod.exports;
	  }
	})(this, function (exports, module) {
	  'use strict';

	  var defaultOptions = {
	    timeout: 5000,
	    jsonpCallback: 'callback',
	    jsonpCallbackFunction: null
	  };

	  function generateCallbackFunction() {
	    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	  }

	  // Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined' error if request timeout
	  function clearFunction(functionName) {
	    // IE8 throws an exception when you try to delete a property on window
	    // http://stackoverflow.com/a/1824228/751089
	    try {
	      delete window[functionName];
	    } catch (e) {
	      window[functionName] = undefined;
	    }
	  }

	  function removeScript(scriptId) {
	    var script = document.getElementById(scriptId);
	    document.getElementsByTagName('head')[0].removeChild(script);
	  }

	  var fetchJsonp = function fetchJsonp(url) {
	    var options = arguments[1] === undefined ? {} : arguments[1];

	    var timeout = options.timeout != null ? options.timeout : defaultOptions.timeout;
	    var jsonpCallback = options.jsonpCallback != null ? options.jsonpCallback : defaultOptions.jsonpCallback;

	    var timeoutId = undefined;

	    return new Promise(function (resolve, reject) {
	      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();

	      window[callbackFunction] = function (response) {
	        resolve({
	          ok: true,
	          // keep consistent with fetch API
	          json: function json() {
	            return Promise.resolve(response);
	          }
	        });

	        if (timeoutId) clearTimeout(timeoutId);

	        removeScript(jsonpCallback + '_' + callbackFunction);

	        clearFunction(callbackFunction);
	      };

	      // Check if the user set their own params, and if not add a ? to start a list of params
	      url += url.indexOf('?') === -1 ? '?' : '&';

	      var jsonpScript = document.createElement('script');
	      jsonpScript.setAttribute('src', url + jsonpCallback + '=' + callbackFunction);
	      jsonpScript.id = jsonpCallback + '_' + callbackFunction;
	      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

	      timeoutId = setTimeout(function () {
	        reject(new Error('JSONP request to ' + url + ' timed out'));

	        clearFunction(callbackFunction);
	        removeScript(jsonpCallback + '_' + callbackFunction);
	      }, timeout);
	    });
	  };

	  // export as global function
	  /*
	  let local;
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	  
	  local.fetchJsonp = fetchJsonp;
	  */

	  module.exports = fetchJsonp;
	});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */

	var debug = __webpack_require__(8)('cookie');

	/**
	 * Set or get cookie `name` with `value` and `options` object.
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @return {Mixed}
	 * @api public
	 */

	module.exports = function(name, value, options){
	  switch (arguments.length) {
	    case 3:
	    case 2:
	      return set(name, value, options);
	    case 1:
	      return get(name);
	    default:
	      return all();
	  }
	};

	/**
	 * Set cookie `name` to `value`.
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @api private
	 */

	function set(name, value, options) {
	  options = options || {};
	  var str = encode(name) + '=' + encode(value);

	  if (null == value) options.maxage = -1;

	  if (options.maxage) {
	    options.expires = new Date(+new Date + options.maxage);
	  }

	  if (options.path) str += '; path=' + options.path;
	  if (options.domain) str += '; domain=' + options.domain;
	  if (options.expires) str += '; expires=' + options.expires.toUTCString();
	  if (options.secure) str += '; secure';

	  document.cookie = str;
	}

	/**
	 * Return all cookies.
	 *
	 * @return {Object}
	 * @api private
	 */

	function all() {
	  var str;
	  try {
	    str = document.cookie;
	  } catch (err) {
	    if (typeof console !== 'undefined' && typeof console.error === 'function') {
	      console.error(err.stack || err);
	    }
	    return {};
	  }
	  return parse(str);
	}

	/**
	 * Get cookie `name`.
	 *
	 * @param {String} name
	 * @return {String}
	 * @api private
	 */

	function get(name) {
	  return all()[name];
	}

	/**
	 * Parse cookie `str`.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */

	function parse(str) {
	  var obj = {};
	  var pairs = str.split(/ *; */);
	  var pair;
	  if ('' == pairs[0]) return obj;
	  for (var i = 0; i < pairs.length; ++i) {
	    pair = pairs[i].split('=');
	    obj[decode(pair[0])] = decode(pair[1]);
	  }
	  return obj;
	}

	/**
	 * Encode.
	 */

	function encode(value){
	  try {
	    return encodeURIComponent(value);
	  } catch (e) {
	    debug('error `encode(%o)` - %o', value, e)
	  }
	}

	/**
	 * Decode.
	 */

	function decode(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    debug('error `decode(%o)` - %o', value, e)
	  }
	}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */

	exports = module.exports = __webpack_require__(10);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();

	/**
	 * Colors.
	 */

	exports.colors = [
	  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
	  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
	  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
	  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
	  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
	  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
	  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
	  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
	  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
	  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
	  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
	];

	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */

	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }

	  // Internet Explorer and Edge do not support colors.
	  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
	    return false;
	  }

	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}

	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */

	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};


	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */

	function formatArgs(args) {
	  var useColors = this.useColors;

	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);

	  if (!useColors) return;

	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')

	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });

	  args.splice(lastC, 0, c);
	}

	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */

	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}

	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */

	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}

	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */

	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}

	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }

	  return r;
	}

	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */

	exports.enable(load());

	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */

	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */

	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(11);

	/**
	 * Active `debug` instances.
	 */
	exports.instances = [];

	/**
	 * The currently active debug mode names, and names to skip.
	 */

	exports.names = [];
	exports.skips = [];

	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */

	exports.formatters = {};

	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */

	function selectColor(namespace) {
	  var hash = 0, i;

	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }

	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}

	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */

	function createDebug(namespace) {

	  var prevTime;

	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;

	    var self = debug;

	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;

	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }

	    args[0] = exports.coerce(args[0]);

	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }

	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);

	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });

	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);

	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }

	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	  debug.destroy = destroy;

	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }

	  exports.instances.push(debug);

	  return debug;
	}

	function destroy () {
	  var index = exports.instances.indexOf(this);
	  if (index !== -1) {
	    exports.instances.splice(index, 1);
	    return true;
	  } else {
	    return false;
	  }
	}

	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */

	function enable(namespaces) {
	  exports.save(namespaces);

	  exports.names = [];
	  exports.skips = [];

	  var i;
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;

	  for (i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }

	  for (i = 0; i < exports.instances.length; i++) {
	    var instance = exports.instances[i];
	    instance.enabled = exports.enabled(instance.namespace);
	  }
	}

	/**
	 * Disable debug output.
	 *
	 * @api public
	 */

	function disable() {
	  exports.enable('');
	}

	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */

	function enabled(name) {
	  if (name[name.length - 1] === '*') {
	    return true;
	  }
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}

	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */

	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */

	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;

	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */

	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};

	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */

	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}

	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}

	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}

	/**
	 * Pluralization helper.
	 */

	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _utils = __webpack_require__(5);

	var _objectAssign = __webpack_require__(13);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**********************************************
	 * created by beth on 2016年7月22日
	 * 登录注册的逻辑
	 **********************************************/
	var verifyCode = {
	  TYPE: 0, // 账号类型， 0格式不正确 1手机号  2邮箱
	  ISNULL: 2, // 非空 0空  1非空  2是初始化
	  ISTYPE: 2, // 格式 0格式不正确  1格式正确  2初始化
	  ISCHKEC: 2, // 去重 0不重复  1重复   2 初始化
	  ISLENGTH: 2, // 密码长度  0 <6位   1 >6位
	  ISSHARP: 2 //密码符号(不能包含#) 0 包含 1 不包含 
	};

	// 登录
	// 获取账号信息
	// 账号验证
	function accountVerify(userCenterApi, type, value) {
	  switch (type) {
	    case 'phone':
	      var verifyCode = (0, _objectAssign2.default)({}, verifyCode, { TYPE: type });
	      if (!value) {
	        return (0, _objectAssign2.default)({}, verifyCode, { ISNULL: 0 });
	      } else if (value && !(0, _utils.verifyPhone)(value)) {
	        return (0, _objectAssign2.default)({}, verifyCode, { ISTYPE: 0 });
	      } else if (value && (0, _utils.verifyPhone)(value) && !accountCheck(userCenterApi, type, value)) {
	        return (0, _objectAssign2.default)({}, verifyCode, { ISCHKEC: 0 });
	      }
	    case 'email':
	      var verifyCode = (0, _objectAssign2.default)({}, verifyCode, { TYPE: type });
	      if (!value) {
	        return (0, _objectAssign2.default)({}, verifyCode, { ISNULL: 0 });
	      } else if (value && !(0, _utils.verifyEmail)(value)) {
	        return (0, _objectAssign2.default)({}, verifyCode, { ISTYPE: 0 });
	      }
	    case 'login':
	      if (!value) {
	        return (0, _objectAssign2.default)({}, verifyCode, { ISNULL: 0 });
	      } else if (!(0, _utils.verifyPhone)(value) && !(0, _utils.verifyEmail)(value)) {
	        return (0, _objectAssign2.default)({}, verifyCode, { ISTYPE: 0 });
	      } else if (!(0, _utils.verifyPhone)(value) && (0, _utils.verifyEmail)(value)) {
	        return (0, _objectAssign2.default)({}, verifyCode, { TYPE: 'email' });
	      } else if ((0, _utils.verifyPhone)(value) && !(0, _utils.verifyEmail)(value)) {
	        return (0, _objectAssign2.default)({}, verifyCode, { TYPE: 'phone' });
	      }
	    default:
	      break;
	      return verifyCode;
	  }
	}

	//密码长度验证
	function passwordVerify(value) {
	  var that = this;
	  if (!value) {
	    return (0, _objectAssign2.default)({}, verifyCode, { ISNULL: 0 });
	  } else if (!(0, _utils.verifyPassword)(value)) {
	    return (0, _objectAssign2.default)({}, verifyCode, { ISLENGTH: 0 });
	  } else if ((0, _utils.verifySharp)(value)) {
	    return (0, _objectAssign2.default)({}, verifyCode, { ISSHARP: 0 });
	  } else {
	    return (0, _objectAssign2.default)({}, verifyCode, { ISLENGTH: 1 });
	  }
	}

	function accountCheck(userCenterApi, type, value, callback) {
	  var newData = {};
	  newData[type] = value.replace(/(^\s+)|(\s+$)/g, "");
	  fetch(userCenterApi + '/signup/check', {
	    method: 'post',
	    headers: {
	      'Content-Type': 'application/x-www-form-urlencoded'
	    },
	    body: (0, _utils.objUrlEncode)(newData)
	  }).then(function (res) {
	    if (res.status == 200) {
	      return res.json();
	    }
	  }).then(function (res) {
	    if (callback && typeof callback === 'function') {
	      if (res.code === 0) {
	        callback((0, _objectAssign2.default)({}, verifyCode, { ISCHKEC: 0 }));
	      } else {
	        callback((0, _objectAssign2.default)({}, verifyCode, { ISCHKEC: 1 }));
	      }
	    }
	  });
	}

	//重新发送邮件  去激活
	function activateEmail(userCenterApi, type, emailValue, smartRedirect, smartUrl) {
	  var smart = null;

	  smart = smartUrl ? smartUrl : '//www.smartstudy.com';

	  /*type : new find*/
	  var that = this;
	  return function () {
	    fetch(userCenterApi + '/captcha/email', {
	      credentials: 'include',
	      method: 'post',
	      headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	      },
	      body: 'type=' + type + '&email=' + emailValue + '&redirect=' + smart + '/confirm?smartRedirect=' + smartRedirect + '?from=' + type
	    }).then(function (response) {
	      return response.json();
	    }).then(function (res) {
	      location.href = smart + '/activateemail?smartRedirect=' + smartRedirect + '&email=' + emailValue + '&from=' + type;
	    });
	  };
	}

	module.exports = {
	  accountVerify: accountVerify,
	  passwordVerify: passwordVerify,
	  accountCheck: accountCheck,
	  activateEmail: activateEmail
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = require("object-assign");

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _config = __webpack_require__(3);

	var _config2 = _interopRequireDefault(_config);

	var _Constants = __webpack_require__(4);

	var _Constants2 = _interopRequireDefault(_Constants);

	var _objectAssign = __webpack_require__(13);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	var _utils = __webpack_require__(5);

	var _utils2 = _interopRequireDefault(_utils);

	var _fetchJsonp = __webpack_require__(6);

	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

	var _componentCookie = __webpack_require__(7);

	var _componentCookie2 = _interopRequireDefault(_componentCookie);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var loginUtils = __webpack_require__(12); /**
	                                                 * Created by xieshanshan on 16/8/1.
	                                                 * 登录注册弹窗
	                                                 */

	//导入组件
	var TitleText = __webpack_require__(15);
	var SignIn = __webpack_require__(16);
	var BtnText = __webpack_require__(17);
	var ErrText = __webpack_require__(18);
	var OtherText = __webpack_require__(19);
	var ThirdLogin = __webpack_require__(20);

	module.exports = _react2.default.createClass({
	  displayName: 'exports',

	  propTypes: function propTypes() {
	    return {
	      login: _react2.default.PropTypes.number, //控制登录组件
	      userCenterApi: _react2.default.PropTypes.userCenterApi,
	      from: _react2.default.PropTypes.string,
	      group: _react2.default.PropTypes.string,
	      openSignUpEmail: _react2.default.PropTypes.func,
	      openSignUp: _react2.default.PropTypes.func,
	      closePop: _react2.default.PropTypes.func
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      login: 1,
	      userCenterApi: _config2.default.api.userCenterApi,
	      from: 'pc',
	      group: 'C',
	      openSignUpEmail: function openSignUpEmail() {
	        console.log('openSignUpEmail');
	      },

	      openSignUp: function openSignUp() {
	        console.log('openSignUp');
	      },

	      closePop: function closePop() {
	        console.log('closePop');
	      }
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      account: (0, _componentCookie2.default)('account') ? (0, _componentCookie2.default)('account') : '',
	      password: '',
	      code: '',
	      verifyCode: 0, //登录失败超过3次
	      btnText: '登录',
	      checked: true,
	      codeImg: this.props.userCenterApi + '/captcha?bg=1',
	      errMsg: {
	        inputErrMsg: '',
	        psdErrMsg: '',
	        captchaErrMsg: '',
	        ISCHKEC: 1, //手机邮箱是否存在
	        ISACTIVATE: 1, //邮箱激活
	        otherMsg: ''
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    var that = this;
	    if (this.state.errMsg.otherMsg) {
	      this.clearErrTimer = null;
	      clearTimeout(this.clearErrTimer);
	      this.clearErrTimer = setTimeout(function () {
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: { otherMsg: '' }
	        }));
	      }, 3000);
	    }
	  },

	  render: function render() {
	    var loginContentStyle = {
	      height: '378px',
	      marginTop: '-190px'
	    };

	    if (this.state.errMsg.otherMsg) {
	      loginContentStyle = {
	        height: '480px',
	        marginTop: '-240px'
	      };
	    } else if (this.state.verifyCode) {
	      loginContentStyle = {
	        height: '450px',
	        marginTop: '-229px'
	      };
	    }

	    var locationHref = location.href.split('#')[0];
	    return _react2.default.createElement(
	      'div',
	      { className: 'login-pop-init' },
	      _react2.default.createElement(
	        'div',
	        { className: 'login-pop-content', style: loginContentStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'login-close' },
	          _react2.default.createElement(
	            'a',
	            { href: 'javascript:;', onClick: this.closePop },
	            _react2.default.createElement(
	              'svg',
	              { width: '24px', height: '24px', viewBox: '0 0 16 16' },
	              _react2.default.createElement('path', { fill: '#ccc', id: 'XMLID_9_', 'class': 'st5', d: 'M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8s8-3.6,8-8C16,3.6,12.4,0,8,0z M10.8,11.3L8,8.6l-2.8,2.8 l-0.6-0.6L7.4,8L4.6,5.2l0.6-0.6L8,7.4l2.8-2.8l0.6,0.6L8.6,8l2.8,2.8L10.8,11.3z' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'sign-content-box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sign-pop' },
	              _react2.default.createElement(TitleText, { titleText: _Constants2.default.LOGIN_TEXT.SIGN_IN_TITLE }),
	              _react2.default.createElement(ErrText, { errMsg: this.state.errMsg.otherMsg }),
	              _react2.default.createElement(SignIn, {
	                loginState: this.loginState,
	                user: this.state,
	                activateEmail: loginUtils.activateEmail,
	                smart: this.props.smart,
	                openSignUp: this.openSignUp,
	                userCenterApi: this.props.userCenterApi,
	                getCode: this.getCode }),
	              _react2.default.createElement(OtherText, { from: 'signin',
	                smart: this.props.smart,
	                loginState: this.loginState,
	                openSignUp: this.openSignUpPhone }),
	              _react2.default.createElement(BtnText, {
	                btnText: _Constants2.default.LOGIN_TEXT.SIGN_IN_BTN,
	                clickBtn: this.loginSubmit,
	                from: 'signin',
	                user: this.state }),
	              _react2.default.createElement(ThirdLogin, {
	                userCenterApi: this.props.userCenterApi,
	                source: this.props.source,
	                group: this.props.group,
	                locationHref: locationHref })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'login-pop-bg' })
	    );
	  },

	  closePop: function closePop() {
	    this.props.closePop();
	  },

	  loginState: function loginState(state) {
	    this.setState(state);
	  },

	  openSignUp: function openSignUp() {
	    if (_utils2.default.verifyEmail(this.state.account)) {
	      this.props.openSignUpEmail(3);
	    } else {
	      this.props.openSignUp(2);
	    }
	  },

	  openSignUpPhone: function openSignUpPhone() {
	    this.props.openSignUp(2);
	  },

	  getCode: function getCode() {
	    this.setState({ codeImg: this.props.userCenterApi + '/captcha?bg=' + Math.random() });
	  },

	  //登录验证
	  loginSubmit: function loginSubmit() {
	    var _state = this.state,
	        account = _state.account,
	        password = _state.password,
	        code = _state.code;

	    var that = this;
	    var verifyCode = loginUtils.accountVerify(that.props.userCenterApi, 'login', account);
	    if (!(verifyCode.ISNULL || verifyCode.ISTYPE) && verifyCode.TYPE) {
	      that.setState({
	        btnText: '正在登录...',
	        errMsg: {}
	      });
	      that.requestLogin(account.replace(/(^\s+)|(\s+$)/g, ""), password, code);
	    } else if (verifyCode.ISNULL == 0) {
	      that.setState((0, _objectAssign2.default)({}, this.state, {
	        errMsg: { inputErrMsg: '手机/邮箱不能为空' }
	      }));
	    } else if (verifyCode.ISTYPE == 0) {
	      that.setState((0, _objectAssign2.default)({}, this.state, {
	        errMsg: { inputErrMsg: '手机/邮箱格式不正确' }
	      }));
	    }
	  },

	  //登录接口
	  requestLogin: function requestLogin(a_username, a_password) {
	    var Redirect = location.href.split('#')[0];
	    var check = this.state.checked;
	    var that = this;
	    (0, _fetchJsonp2.default)(this.props.userCenterApi + '/signin?from=' + this.props.from + '&group=' + this.props.group + '&account=' + a_username + '&password=' + a_password + '&captcha=' + this.state.code + '&smartRedirect=' + encodeURIComponent(Redirect), {
	      jsonpCallback: 'smartCallback',
	      jsonpCallbackFunction: 'display',
	      credentials: 'include'
	    }).then(function (response) {
	      return response.json();
	    }).then(function (res) {
	      if (res && res.succeed) {
	        if (check) {
	          (0, _componentCookie2.default)('account', that.state.account, { expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 7), path: '/' });
	        } else {
	          (0, _componentCookie2.default)('account', null, { expires: new Date(-1), path: '/' });
	        }
	        that.setState({
	          btnText: '登录'
	        });
	        //登录成功 调用回调函数
	        that.props.signSuccessCallback(res.succeed);
	      } else if (res && res.code == 10203) {
	        that.getCode();
	        if (that.state.verifyCode == 1) {
	          that.setState((0, _objectAssign2.default)({}, that.state, {
	            errMsg: { psdErrMsg: '密码不正确' },
	            btnText: '登录'
	          }));
	          return false;
	        }
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          verifyCode: 1
	        }));
	      } else if (res && res.code == 10102) {
	        that.getCode();
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: { captchaErrMsg: '验证码错误' },
	          btnText: '登录'
	        }));
	      } else if (res && res.code == 10204) {
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: { inputErrMsg: '邮箱未激活', ISACTIVATE: 0 }
	        }));
	      } else if (res && res.code == 10205 || res.code == 10406) {
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: { inputErrMsg: '账号不存在', ISCHKEC: 0 }
	        }));
	      } else {
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: { psdErrMsg: '密码不正确' },
	          btnText: '登录'
	        }));
	      }
	    }).catch(function (ex) {
	      console.log('parsing failed', ex); //eslint-disable-line no-console
	    });
	  }
	});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(2);

	module.exports = React.createClass({
	  displayName: 'exports',

	  propTypes: {
	    from: React.PropTypes.string,
	    titleText: React.PropTypes.string
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      from: '',
	      titleText: '登录'
	    };
	  },

	  render: function render() {
	    if (this.props.from == 'phone') {
	      return React.createElement(
	        'div',
	        { className: 'title  phone-title' },
	        React.createElement(
	          'p',
	          null,
	          this.props.titleText
	        ),
	        React.createElement(
	          'span',
	          null,
	          '\u6CE8\u518C\u5373\u8D60\u9001100\u5143\u4EE3\u91D1\u5238'
	        )
	      );
	    }
	    return React.createElement(
	      'div',
	      { className: 'title', 'dt-data': this.props.titleText },
	      React.createElement(
	        'p',
	        null,
	        this.props.titleText
	      )
	    );
	  }
	});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _config = __webpack_require__(3);

	var _config2 = _interopRequireDefault(_config);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var React = __webpack_require__(2);


	module.exports = React.createClass({
	  displayName: 'exports',

	  propTypes: function propTypes() {
	    return {
	      userCenterApi: React.PropTypes.string,
	      loginState: React.PropTypes.func,
	      user: React.PropTypes.shape({
	        account: React.PropTypes.string,
	        password: React.PropTypes.string,
	        code: React.PropTypes.string,
	        verifyCode: React.PropTypes.number,
	        errMsg: React.PropTypes.shape({
	          inputErrMsg: React.PropTypes.string,
	          psdErrMsg: React.PropTypes.string,
	          captchaErrMsg: React.PropTypes.string,
	          ISCHKEC: React.PropTypes.number,
	          ISACTIVATE: React.PropTypes.number
	        })
	      }),
	      smartRedirect: React.PropTypes.string,
	      smart: React.PropTypes.string,
	      openSignUp: React.PropTypes.func,
	      activateEmail: React.PropTypes.func
	    };
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      userCenterApi: _config2.default.api.userCenterApi,

	      loginState: function loginState(state) {
	        console.log('loginState', state);
	      },
	      user: {
	        account: 'xieshanshan@innobuddy.com',
	        password: '123456',
	        code: '',
	        verifyCode: 0,
	        errMsg: {
	          inputErrMsg: '',
	          psdErrMsg: '',
	          captchaErrMsg: '',
	          ISCHKEC: 1,
	          ISACTIVATE: 1
	        }
	      },
	      smartRedirect: 'www.smartstudy.com/',
	      smart: 'www.smartstudy.com/',

	      openSignUp: function openSignUp() {
	        console.log('openSignUp');
	      },

	      activateEmail: function activateEmail() {
	        console.log('activateEmail');
	      }
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      showPassword: 0,
	      checked: true,
	      accountCss: 0,
	      passwordCss: 0,
	      captchaCss: 0
	    };
	  },

	  handleInputChange: function handleInputChange(name, num) {
	    var that = this;
	    return function (event) {
	      var newState = {};
	      newState[name] = event.target.value;
	      that.props.loginState(newState);
	      that.handleInputFun(name, num);
	    };
	  },

	  handleInputFun: function handleInputFun(name, num) {
	    var that = this;
	    if (name == 'account') {
	      that.state.accountCss != num && that.setState({
	        accountCss: num
	      });
	    } else if (name == 'password') {
	      that.state.passwordCss != num && that.setState({
	        passwordCss: num
	      });
	    } else if (name == 'code') {
	      that.state.captchaCss != num && that.setState({
	        captchaCss: num
	      });
	    }
	  },

	  handleInputFocus: function handleInputFocus(name, num) {
	    var that = this;
	    return function () {
	      if (name == 'account') {
	        var newState = {
	          errMsg: { inputErrMsg: '', ISCHKEC: 1, ISACTIVATE: 1 },
	          btnText: '登录'
	        };
	      } else if (name == 'password') {
	        var newState = {
	          errMsg: { psdErrMsg: '' },
	          btnText: '登录'
	        };
	      } else if (name == 'code') {
	        var newState = {
	          errMsg: { captchaErrMsg: '' },
	          btnText: '登录'
	        };
	      } else {
	        var newState = {};
	      }

	      that.props.loginState(newState);
	      that.handleInputFun(name, num);
	    };
	  },

	  handleInputBlur: function handleInputBlur(name, num) {
	    var that = this;
	    return function () {
	      that.handleInputFun(name, num);
	    };
	  },

	  handleInputClassName: function handleInputClassName(errName, stateName) {
	    var inputClass;
	    if (errName) {
	      inputClass = 'input-err';
	    } else {
	      if (stateName == 0) {
	        inputClass = 'user-input-info';
	      } else if (stateName == 1) {
	        inputClass = 'input-focus';
	      } else if (stateName == 2) {
	        inputClass = 'input-blur';
	      }
	    }
	    return inputClass;
	  },

	  render: function render() {
	    var _props$user = this.props.user,
	        account = _props$user.account,
	        password = _props$user.password,
	        code = _props$user.code,
	        verifyCode = _props$user.verifyCode;
	    var _props$user$errMsg = this.props.user.errMsg,
	        psdErrMsg = _props$user$errMsg.psdErrMsg,
	        inputErrMsg = _props$user$errMsg.inputErrMsg,
	        captchaErrMsg = _props$user$errMsg.captchaErrMsg,
	        ISCHKEC = _props$user$errMsg.ISCHKEC,
	        ISACTIVATE = _props$user$errMsg.ISACTIVATE;
	    var _state = this.state,
	        showPassword = _state.showPassword,
	        accountCss = _state.accountCss,
	        passwordCss = _state.passwordCss,
	        captchaCss = _state.captchaCss;

	    var smartRedirect = this.props.smartRedirect ? this.props.smartRedirect : '';
	    var userIconClassName = account || accountCss ? 'user-icon-s' : 'user-icon-h';
	    var psdIconClassName = password || passwordCss ? 'psd-icon-s' : 'psd-icon-h';

	    var psdInputClassName = this.handleInputClassName(psdErrMsg, passwordCss);
	    var userInputClassName = this.handleInputClassName(inputErrMsg, accountCss);
	    var captchaClassName = this.handleInputClassName(captchaErrMsg, captchaCss);

	    var Redirect = smartRedirect ? smartRedirect : this.props.smart;

	    var signUpBtn = null;
	    if (ISCHKEC == 0) {
	      signUpBtn = React.createElement(
	        'a',
	        { href: 'javascript:;', className: 'go-submit-btn',
	          onClick: this.props.openSignUp },
	        '\u53BB\u6CE8\u518C'
	      );
	    } else if (ISACTIVATE == 0) {
	      signUpBtn = React.createElement(
	        'a',
	        { href: 'javascript:;', className: 'go-submit-btn',
	          onClick: this.props.activateEmail(this.props.userCenterApi, 'new', account, Redirect, this.props.smart) },
	        '\u53BB\u6FC0\u6D3B'
	      );
	    }

	    if (ISCHKEC == 0 || ISACTIVATE == 0) {
	      var errInputInfo = React.createElement(
	        'span',
	        { className: 'red' },
	        inputErrMsg
	      );
	    } else {
	      var errInputInfo = React.createElement(
	        'div',
	        { className: 'err-msg', style: { display: inputErrMsg ? 'block' : 'none', right: '35px' } },
	        React.createElement(
	          'i',
	          null,
	          '!'
	        ),
	        React.createElement(
	          'span',
	          null,
	          inputErrMsg
	        )
	      );
	    }

	    return React.createElement(
	      'div',
	      { id: 'signInputBoxId' },
	      React.createElement(
	        'div',
	        { className: 'item account' },
	        React.createElement('input', {
	          name: 'account',
	          type: 'text', placeholder: '\u624B\u673A/\u90AE\u7BB1',
	          className: userInputClassName,
	          onChange: this.handleInputChange('account', 1),
	          onFocus: this.handleInputFocus('account', 1),
	          onBlur: this.handleInputBlur('account', 2),
	          value: account
	        }),
	        React.createElement('i', { className: userIconClassName }),
	        errInputInfo,
	        signUpBtn
	      ),
	      React.createElement(
	        'div',
	        { className: 'item account' },
	        React.createElement('input', { name: 'password', type: showPassword ? 'text' : 'password', placeholder: '\u5BC6\u7801\uFF08\u81F3\u5C116\u4F4D\u4EFB\u610F\u5B57\u7B26\u7EC4\u5408\uFF09',
	          className: psdInputClassName,
	          onChange: this.handleInputChange('password', 1),
	          onFocus: this.handleInputFocus('password', 1),
	          onBlur: this.handleInputBlur('password', 2),
	          value: password }),
	        React.createElement('i', { className: psdIconClassName }),
	        React.createElement('a', { className: showPassword ? 'password_h' : 'password_s', href: 'javascript:;', onClick: this.showPassword }),
	        React.createElement(
	          'div',
	          { className: 'err-msg', style: { display: psdErrMsg ? 'block' : 'none' } },
	          React.createElement(
	            'i',
	            null,
	            '!'
	          ),
	          React.createElement(
	            'span',
	            null,
	            psdErrMsg
	          )
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'item code', style: { display: verifyCode ? 'block' : 'none' } },
	        React.createElement('input', { name: 'code', type: 'text', placeholder: '\u586B\u5199\u9A8C\u8BC1\u7801',
	          style: { paddingLeft: '20px' },
	          onChange: this.handleInputChange('code', 1),
	          onFocus: this.handleInputFocus('code', 1),
	          onBlur: this.handleInputBlur('code', 2),
	          className: captchaClassName,
	          value: code }),
	        React.createElement(
	          'span',
	          { className: 'get-code' },
	          React.createElement('img', { src: this.props.user.codeImg, alt: '\u9A8C\u8BC1\u7801', height: '20', align: 'bottom', title: '\u770B\u4E0D\u6E05\u53EF\u5355\u51FB\u56FE\u7247\u5237\u65B0',
	            onClick: this.props.getCode })
	        ),
	        React.createElement('b', { className: 'xuanzhuan', onClick: this.props.getCode }),
	        React.createElement(
	          'div',
	          { className: 'err-msg captcha-err-msg', style: { display: captchaErrMsg ? 'block' : 'none' } },
	          React.createElement(
	            'i',
	            null,
	            '!'
	          ),
	          React.createElement(
	            'span',
	            null,
	            captchaErrMsg
	          )
	        )
	      )
	    );
	  },

	  showPassword: function showPassword() {
	    var that = this;
	    this.setState({
	      showPassword: !that.state.showPassword
	    });
	  },

	  changeCheckbox: function changeCheckbox() {
	    var that = this;
	    this.setState({
	      checked: !that.state.checked
	    });
	    that.props.loginState({
	      checked: !that.state.checked
	    });
	  }

	});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(2);

	module.exports = React.createClass({
	  displayName: 'exports',

	  propTypes: {
	    clickBtn: React.PropTypes.func,
	    user: React.PropTypes.shape({
	      account: React.PropTypes.string,
	      phone: React.PropTypes.string,
	      password: React.PropTypes.string,
	      code: React.PropTypes.string,
	      captcha: React.PropTypes.string,
	      email: React.PropTypes.string,
	      verifyCode: React.PropTypes.number,
	      checked: React.PropTypes.bool,
	      btnText: React.PropTypes.string
	    })
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      clickBtn: function clickBtn() {
	        console.log('clickBtn');
	      },
	      user: {
	        account: 'xieshanshan@innobuddy.com',
	        phone: '15321801871',
	        email: 'xieshanshan@innobuddy.com',
	        password: '123456',
	        code: 'nbsp',
	        captcha: '888888',
	        verifyCode: 1,
	        checked: true,
	        btnText: '登录'
	      }
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      account: '',
	      password: '',
	      checked: ''
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    var that = this;
	    /* eslint-disable */
	    var signInputs = document.getElementById('signInputBoxId').getElementsByTagName('input');
	    if (signInputs && signInputs.length > 0) {
	      (function () {
	        for (var i = 0; i < signInputs.length; i++) {
	          signInputs[i].onkeydown = function (e) {
	            var curKey = e.keyCode;
	            if (curKey == 13) {
	              that.props.clickBtn();
	              return false;
	            }
	          };
	        }
	      })();
	    }
	    /* eslint-enable */
	  },

	  handleInputChange: function handleInputChange(name) {
	    var that = this;
	    return function (event) {
	      var newState = {};
	      if (name == 'checked') {
	        newState[name] = event.target.checked;
	      } else {
	        newState[name] = event.target.value;
	      }
	      that.setState(newState);
	    };
	  },

	  render: function render() {
	    var _props$user = this.props.user,
	        account = _props$user.account,
	        password = _props$user.password,
	        code = _props$user.code,
	        verifyCode = _props$user.verifyCode,
	        phone = _props$user.phone,
	        captcha = _props$user.captcha,
	        checked = _props$user.checked,
	        email = _props$user.email;

	    switch (this.props.from) {
	      case 'signin':
	        var submitClassName = account && password && (code && verifyCode || !verifyCode) ? 'input-submit' : 'no-submit';
	        break;
	      case 'phone':
	        var submitClassName = phone && password && checked && (code && captcha || captcha) ? 'input-submit' : 'no-submit';
	        break;
	      case 'email':
	        var submitClassName = email && password && checked && code ? 'input-submit' : 'no-submit';
	    }

	    return React.createElement(
	      'div',
	      null,
	      React.createElement('input', { className: submitClassName, id: 'signInputBoxId', type: 'submit', value: this.props.user.btnText,
	        onClick: this.props.clickBtn })
	    );
	  }
	});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(2);

	module.exports = React.createClass({
	  displayName: 'exports',

	  propTypes: {
	    errMsg: React.PropTypes.string
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      errMsg: ''
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'err-content', style: { display: this.props.errMsg ? 'block' : 'none' } },
	      React.createElement(
	        'i',
	        null,
	        '!'
	      ),
	      React.createElement(
	        'span',
	        null,
	        this.props.errMsg
	      )
	    );
	  }
	});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(2);

	module.exports = React.createClass({
	  displayName: 'exports',

	  propTypes: {
	    from: React.PropTypes.string,
	    clickBtn: React.PropTypes.func,
	    openSignIn: React.PropTypes.func,
	    openSignUp: React.PropTypes.func,
	    loginState: React.PropTypes.func,
	    smartRedirect: React.PropTypes.string
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      from: 'signin',
	      clickBtn: function clickBtn() {
	        console.log('clickBtn');
	      },
	      openSignIn: function openSignIn() {
	        console.log('openSignIn');
	      },
	      openSignUp: function openSignUp() {
	        console.log('openSignUp');
	      },
	      loginState: function loginState(state) {
	        console.log('loginState', state);
	      },
	      smartRedirect: 'www.smartstudy.com/'
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      checked: true
	    };
	  },

	  render: function render() {
	    var from = this.props.from;

	    var changeStyle = from == 'signin' ? 'item change right' : 'item change';
	    var signUpBtn = null;
	    var otherText = null;
	    if (from == 'phone') {
	      signUpBtn = React.createElement(
	        'a',
	        { href: 'javascript:;', onClick: this.props.clickBtn },
	        '\u90AE\u7BB1\u6CE8\u518C'
	      );
	    } else if (from == 'email') {
	      signUpBtn = React.createElement(
	        'a',
	        { href: 'javascript:;', onClick: this.props.clickBtn },
	        '\u624B\u673A\u6CE8\u518C'
	      );
	    }

	    otherText = React.createElement(
	      'span',
	      { className: 'changeType' },
	      '\u5DF2\u6709\u5E10\u53F7?',
	      React.createElement(
	        'a',
	        { href: 'javascript:;', onClick: this.props.openSignIn },
	        '\u53BB\u767B\u5F55'
	      )
	    );

	    if (from == 'signin') {
	      signUpBtn = null;
	      otherText = React.createElement(
	        'div',
	        { className: 'other' },
	        React.createElement(
	          'span',
	          { className: 'checkbox' },
	          React.createElement('input', { type: 'checkbox',
	            onChange: this.handleInputChange('checked'),
	            checked: this.state.checked }),
	          React.createElement(
	            'a',
	            { className: 'a_checked', href: 'javascript:;', onClick: this.changeCheckbox },
	            '\u4E0B\u6B21\u81EA\u52A8\u767B\u5F55'
	          )
	        ),
	        React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'a',
	            { className: 'findpassword', href: 'javascript:;', onClick: this.findPassword },
	            '\u5FD8\u8BB0\u5BC6\u7801'
	          ),
	          React.createElement(
	            'i',
	            null,
	            '|'
	          ),
	          React.createElement(
	            'a',
	            { href: 'javascript:;', onClick: this.props.openSignUp },
	            '\u7ACB\u5373\u6CE8\u518C'
	          )
	        )
	      );
	    }

	    return React.createElement(
	      'div',
	      { className: changeStyle },
	      signUpBtn,
	      otherText
	    );
	  },

	  handleInputChange: function handleInputChange(name) {
	    var that = this;
	    return function (event) {
	      var newState = {};
	      newState[name] = event.target.checked;
	      that.setState(newState);
	      that.props.loginState(newState);
	    };
	  },

	  changeCheckbox: function changeCheckbox() {
	    this.setState({
	      checked: !this.state.checked
	    });

	    this.props.loginState({
	      checked: !this.state.checked
	    });
	  },

	  //找回密码
	  findPassword: function findPassword() {
	    var smartRedirect = this.props.smartRedirect;
	    var Redirect = smartRedirect ? smartRedirect : location.href.split('#')[0];
	    if (typeof window === 'undefined') return;
	    if (window && window.open) {
	      window.open(this.props.smart + '/find?smartRedirect=' + Redirect, '_blank');
	    }
	  }
	});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _config = __webpack_require__(3);

	var _config2 = _interopRequireDefault(_config);

	var _Constants = __webpack_require__(4);

	var _Constants2 = _interopRequireDefault(_Constants);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var React = __webpack_require__(2);


	module.exports = React.createClass({
	  displayName: 'exports',


	  propTypes: function propTypes() {
	    return {
	      userCenterApi: React.PropTypes.string,
	      smart: React.PropTypes.string,
	      from: React.PropTypes.string,
	      group: React.PropTypes.string,
	      source: React.PropTypes.string
	    };
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      userCenterApi: _config2.default.api.userCenterApi,
	      smart: 'www.smartstudy.com/',
	      from: 'pc',
	      group: 'C',
	      source: 'www.smartstudy.com'
	    };
	  },

	  render: function render() {
	    var url = this.props.userCenterApi;
	    var smartRedirect = this.props.locationHref;

	    var parameter = '&flag=signin&source=' + this.props.source + '&from=' + this.props.from + '&group=' + this.props.group + '&smartRedirect=' + smartRedirect;

	    var qq = url + '/third/authorize?type=' + _Constants2.default.THIRD_LOGIN.QQ + parameter;

	    var weixin = url + '/third/authorize?type=' + _Constants2.default.THIRD_LOGIN.WEIXIN + parameter;

	    var weibo = url + '/third/authorize?type=' + _Constants2.default.THIRD_LOGIN.WEIBO + parameter;

	    var baidu = url + '/third/authorize?type=' + _Constants2.default.THIRD_LOGIN.BAIDU + parameter;

	    return React.createElement(
	      'div',
	      { className: 'third' },
	      React.createElement('span', { className: 'line' }),
	      React.createElement(
	        'span',
	        { className: 'line-text' },
	        '\u4F7F\u7528\u7B2C\u4E09\u65B9\u8D26\u53F7\u767B\u5F55'
	      ),
	      React.createElement('span', { className: 'line-right' }),
	      React.createElement('a', { className: 'icon icon-qq', href: qq }),
	      React.createElement('a', { className: 'icon icon-weixin', href: weixin }),
	      React.createElement('a', { className: 'icon icon-weibo', href: weibo }),
	      React.createElement('a', { className: 'icon icon-baidu', href: baidu })
	    );
	  }
	});

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _config = __webpack_require__(3);

	var _config2 = _interopRequireDefault(_config);

	var _Constants = __webpack_require__(4);

	var _Constants2 = _interopRequireDefault(_Constants);

	var _objectAssign = __webpack_require__(13);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	var _fetchJsonp = __webpack_require__(6);

	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

	var _componentCookie = __webpack_require__(7);

	var _componentCookie2 = _interopRequireDefault(_componentCookie);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var loginUtils = __webpack_require__(12); /**
	                                                 * Created by xieshanshan on 16/8/1.
	                                                 * 登录注册弹窗
	                                                 */

	//导入组件
	var TitleText = __webpack_require__(15);
	var SignUpEmail = __webpack_require__(22);
	var SignUpPhone = __webpack_require__(23);
	var BtnText = __webpack_require__(17);
	var ErrText = __webpack_require__(18);
	var OtherText = __webpack_require__(19);
	var UserAgreement = __webpack_require__(25);

	module.exports = _react2.default.createClass({
	  displayName: 'exports',

	  propTypes: function propTypes() {
	    return {
	      login: _react2.default.PropTypes.string,
	      userCenterApi: _react2.default.PropTypes.string, //后台接口api
	      card: _react2.default.PropTypes.string, //代金券api
	      from: _react2.default.PropTypes.string,
	      group: _react2.default.PropTypes.string,
	      smart: _react2.default.PropTypes.string,
	      source: _react2.default.PropTypes.string,
	      detail: _react2.default.PropTypes.string,
	      closePop: _react2.default.PropTypes.func,
	      openSignUpEmail: _react2.default.PropTypes.func,
	      openSignUp: _react2.default.PropTypes.func,
	      openSignIn: _react2.default.PropTypes.func,
	      userInfo: _react2.default.PropTypes.shape({
	        token: _react2.default.PropTypes.string,
	        uid: _react2.default.PropTypes.string
	      })
	    };
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      login: 2,
	      userCenterApi: _config2.default.api.userCenterApi,
	      card: _config2.default.api.card,
	      from: 'pc',
	      group: 'C',
	      smart: 'www.smartstudy.com/',
	      source: 'www.smartstudy.com',
	      detail: '',
	      closePop: function closePop() {
	        console.log('closePop');
	      },

	      openSignUpEmail: function openSignUpEmail() {
	        console.log('openSignUpEmail');
	      },

	      openSignUp: function openSignUp() {
	        console.log('openSignUp');
	      },

	      openSignIn: function openSignIn() {
	        console.log('openSignIn');
	      },

	      userInfo: {
	        token: '',
	        uid: ''
	      }
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      phone: '',
	      email: '',
	      password: '',
	      code: '',
	      captcha: '',
	      isResigter: true,
	      checked: true,
	      btnText: '注册',
	      time: 0,
	      captchaNum: 0, //是不是第二次获取验证码验证码
	      codeImg: this.props.userCenterApi + '/captcha?bg=1', //第二次获取验证码改变codeImg

	      errMsg: {
	        inputErrMsg: '',
	        psdErrMsg: '',
	        captchaErrMsg: '',
	        codeErrMsg: '',
	        ISCHKEC: 2, //手机邮箱是否存在   0 不存在 1 存在
	        ISLENGTH: 0,
	        otherMsg: ''
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    var that = this;
	    if (this.state.errMsg.otherMsg) {
	      this.clearErrTimer = null;
	      clearTimeout(this.clearErrTimer);
	      this.clearErrTimer = setTimeout(function () {
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: { otherMsg: '' }
	        }));
	      }, 3000);
	    }
	  },

	  handleFormContent: function handleFormContent() {

	    if (this.props.login == 3) {
	      return _react2.default.createElement(SignUpEmail, {
	        loginState: this.loginState,
	        openSignIn: this.openSignIn,
	        user: this.state,
	        userCenterApi: this.props.userCenterApi,
	        verifyAccountCheck: this.verifyAccountCheck,
	        verifyPasswordCheck: this.verifyPasswordCheck });
	    } else if (this.props.login == 2) {
	      return _react2.default.createElement(SignUpPhone, {
	        loginState: this.loginState,
	        openSignIn: this.openSignIn,
	        getCode: this.getCode,
	        mini: 'true',
	        getCaptcha: this.getCaptcha,
	        user: this.state,
	        ajaxCaptcha: this.ajaxCaptcha,
	        verifyAccountCheck: this.verifyAccountCheck,
	        verifyPasswordCheck: this.verifyPasswordCheck });
	    } else {
	      return null;
	    }
	  },

	  render: function render() {
	    var login = this.props.login;
	    var divStyle = {
	      height: '378px',
	      marginTop: '-186px'
	    };

	    if (login == 2) {
	      divStyle = {
	        height: '478px',
	        marginTop: '-236px'
	      };
	    }

	    var from = login == 2 ? 'phone' : 'email';
	    return _react2.default.createElement(
	      'div',
	      { className: 'login-pop-init' },
	      _react2.default.createElement(
	        'div',
	        { className: 'login-pop-content', style: divStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'login-close' },
	          _react2.default.createElement(
	            'a',
	            { href: 'javascript:;', onClick: this.closePop },
	            _react2.default.createElement(
	              'svg',
	              { width: '24px', height: '24px', viewBox: '0 0 16 16' },
	              _react2.default.createElement('path', { fill: '#ccc', id: 'XMLID_9_', 'class': 'st5', d: 'M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8s8-3.6,8-8C16,3.6,12.4,0,8,0z M10.8,11.3L8,8.6l-2.8,2.8 l-0.6-0.6L7.4,8L4.6,5.2l0.6-0.6L8,7.4l2.8-2.8l0.6,0.6L8.6,8l2.8,2.8L10.8,11.3z' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'sign-content-box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sign-pop' },
	              _react2.default.createElement(TitleText, { titleText: _Constants2.default.LOGIN_TEXT.SIGN_UP_TITLE, from: login == 2 ? 'phone' : 'email' }),
	              _react2.default.createElement(ErrText, { errMsg: this.state.errMsg.otherMsg }),
	              this.handleFormContent(),
	              _react2.default.createElement(UserAgreement, { loginState: this.loginState, smart: this.props.smart }),
	              _react2.default.createElement(BtnText, {
	                clickBtn: this.clickBtnFun,
	                from: from,
	                user: this.state }),
	              _react2.default.createElement(OtherText, {
	                clickBtn: this.clickFun,
	                from: from,
	                smart: this.props.smart,
	                openSignIn: this.openSignIn })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'login-pop-bg' })
	    );
	  },

	  initState: function initState() {
	    this.setState({
	      phone: '',
	      email: '',
	      password: '',
	      code: '',
	      captcha: '',
	      isResigter: true,
	      checked: true,
	      btnText: '注册',
	      time: 0,
	      captchaNum: 0, //是不是第二次获取验证码验证码
	      codeImg: this.props.userCenterApi + '/captcha?bg=1', //第二次获取验证码改变codeImg
	      errMsg: {
	        inputErrMsg: '',
	        psdErrMsg: '',
	        captchaErrMsg: '',
	        codeErrMsg: '',
	        ISCHKEC: 2, //手机邮箱是否存在   0 不存在 1 存在
	        ISLENGTH: 0,
	        otherMsg: ''
	      }
	    });
	  },

	  closePop: function closePop() {
	    this.props.closePop();
	  },

	  getCode: function getCode() {
	    this.setState({ codeImg: this.props.userCenterApi + '/captcha?bg=' + Math.random() });
	  },

	  loginState: function loginState(state) {
	    var that = this;
	    state = (0, _objectAssign2.default)({}, this.state, state);
	    this.setState(state);
	  },

	  clickFun: function clickFun() {
	    if (this.props.login == 2) {
	      this.initState();
	      this.props.openSignUpEmail(3);
	    } else if (this.props.login == 3) {
	      this.initState();
	      this.props.openSignUp(2);
	    }
	  },

	  openSignIn: function openSignIn() {
	    this.props.openSignIn(1);
	  },

	  //验证账号
	  verifyAccountCheck: function verifyAccountCheck(userCenterApi, type, value) {
	    var _state = this.state,
	        phone = _state.phone,
	        email = _state.email,
	        code = _state.code;

	    var that = this;
	    var verifyCode = loginUtils.accountVerify(userCenterApi, type, value);

	    var errInfo = type == 'email' ? '邮箱' : '手机号码';

	    if (verifyCode.ISNULL == 0) {
	      that.setState((0, _objectAssign2.default)({}, this.state, {
	        errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { inputErrMsg: errInfo + '不能为空' })
	      }));
	    } else if (verifyCode.ISTYPE == 0) {
	      that.setState((0, _objectAssign2.default)({}, this.state, {
	        errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { inputErrMsg: errInfo + '格式不正确' })
	      }));
	    } else if (!(verifyCode.ISNULL || verifyCode.ISTYPE)) {
	      loginUtils.accountCheck(that.props.userCenterApi, verifyCode.TYPE, value, function (code) {
	        if (code.ISCHKEC == 1) {
	          // 手机/邮箱存在
	          that.setState((0, _objectAssign2.default)({}, that.state, {
	            errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { inputErrMsg: errInfo + '存在', ISCHKEC: 1 })
	          }));
	        } else if (!code.ISCHKEC) {
	          that.setState((0, _objectAssign2.default)({}, that.state, {
	            errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { ISCHKEC: 0 })
	          }));
	        }
	      });
	    }
	  },

	  //验证密码
	  verifyPasswordCheck: function verifyPasswordCheck() {
	    var verifyCode = loginUtils.passwordVerify(this.state.password);
	    if (verifyCode.ISNULL == 0) {
	      this.setState((0, _objectAssign2.default)({}, this.state, {
	        errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { psdErrMsg: '密码不能为空' })
	      }));
	    } else if (verifyCode.ISLENGTH == 0) {
	      this.setState((0, _objectAssign2.default)({}, this.state, {
	        errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { psdErrMsg: '密码不能小于6位数', ISLENGTH: 0 })
	      }));
	    } else if (verifyCode.ISSHARP == 0) {
	      this.setState(_.assign({}, this.state, {
	        errMsg: _.assign({}, this.state.errMsg, { psdErrMsg: '密码不能包含#' })
	      }));
	    } else if (verifyCode.ISLENGTH == 1) {
	      this.setState((0, _objectAssign2.default)({}, this.state, {
	        errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { ISLENGTH: 1 })
	      }));
	    }
	  },

	  //获取验证码
	  getCaptcha: function getCaptcha() {
	    var that = this;
	    this.verifyAccountCheck(that.props.userCenterApi, 'phone', this.state.phone);
	    if (!this.state.code) {
	      this.setState((0, _objectAssign2.default)({}, this.state, {
	        errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { codeErrMsg: "验证码不能为空" })
	      }));
	      return false;
	    }

	    if (this.state.errMsg.ISCHKEC == 0) {
	      //发送验证码
	      this.ajaxCaptcha();
	    }
	  },

	  //发送验证码
	  ajaxCaptcha: function ajaxCaptcha() {
	    var that = this;
	    var phone = this.state.phone.replace(/(^\s+)|(\s+$)/g, "");
	    (0, _fetchJsonp2.default)(this.props.userCenterApi + '/captcha/phone/jsonp?type=pc&phone=' + phone + '&captcha=' + this.state.code, {
	      jsonpCallback: 'smartCallback'
	    }).then(function (response) {
	      return response.json();
	    }).then(function (res) {
	      if (res && res.succeed) {
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { codeErrMsg: '' })
	        }));
	        that.regetCaptcha(60);
	      } else {
	        if (res && res.code == 10102) {
	          //验证码错误
	          that.setState((0, _objectAssign2.default)({}, that.state, {
	            errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { codeErrMsg: '验证码错误' }),
	            codeImg: that.props.userCenterApi + '/captcha?bg=' + Math.random()
	          }));
	        } else if (res && res.code == 10104) {
	          //获取失败 请稍候再试
	          that.setState((0, _objectAssign2.default)({}, that.state, {
	            errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { otherMsg: '操作过于频繁，请稍后再试' })
	          }));
	        } else {
	          that.regetCaptcha(3);
	        }
	      }
	    });
	  },

	  // N秒后重新获取
	  regetCaptcha: function regetCaptcha(time, clear) {
	    var that = this;
	    if (clear) {
	      clearTimeout(this.clearCaptchaTimer);
	      this.clearCaptchaTimer = null;
	      this.setState({
	        time: 0
	      });
	      return;
	    }

	    this.clearCaptchaTimer = null;
	    if (time >= 0) {
	      this.clearCaptchaTimer = setTimeout(function () {
	        if (time == 0) {
	          clearTimeout(that.clearCaptchaTimer);
	          that.clearCaptchaTimer = null;
	        }
	        that.setState({
	          time: time
	        });
	        that.regetCaptcha(time - 1);
	      }, 1000);
	    }
	  },

	  clickBtnFun: function clickBtnFun() {
	    var login = this.props.login;
	    if (login == 3) {
	      this.submitResigterEmail();
	    } else if (login == 2) {
	      this.submitResigter();
	    }
	  },

	  //手机注册验证
	  submitResigter: function submitResigter() {
	    var _state2 = this.state,
	        captcha = _state2.captcha,
	        code = _state2.code,
	        checked = _state2.checked;

	    var that = this;
	    this.verifyAccountCheck(that.props.userCenterApi, 'phone', this.state.phone);
	    this.verifyPasswordCheck();
	    if (this.state.errMsg.ISCHKEC == 0 && this.state.errMsg.ISLENGTH == 1) {
	      if (!captcha) {
	        that.setState((0, _objectAssign2.default)({}, this.state, {
	          errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { captchaErrMsg: '短信验证码不能为空' })
	        }));
	      } else if (!code) {
	        that.setState((0, _objectAssign2.default)({}, this.state, {
	          errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { codeErrMsg: '图形验证码不能为空' })
	        }));
	      } else if (!checked) {
	        that.setState((0, _objectAssign2.default)({}, this.state, {
	          errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { otherMsg: '请选择用户用户协议' })
	        }));
	      } else {
	        this.setState({
	          btnText: ' 正在注册...',
	          time: 0
	        });
	        this.requestResigter();
	      }
	    }
	  },

	  //手机注册接口
	  requestResigter: function requestResigter() {
	    var that = this;
	    var phone = this.state.phone.replace(/(^\s+)|(\s+$)/g, "");
	    (0, _fetchJsonp2.default)(this.props.userCenterApi + '/signup/phone/jsonp?phone=' + phone + '&password=' + this.state.password + '&from=' + this.props.from + '&group=' + this.props.group + '&captchaPhone=' + this.state.captcha + '&captcha=' + this.state.code + '&source=' + this.props.smart + '&detail=' + this.props.detail, {
	      jsonpCallback: 'smartCallback',
	      jsonpCallbackFunction: 'display'
	    }).then(function (response) {
	      return response.json();
	    }).then(function (res) {
	      if (res && res.succeed) {
	        //晶赞
	        if (typeof window === 'undefined') return;
	        if (window && window.jing_zan_push) {
	          window.jing_zan_push({
	            pagetype: 'regSuccess',
	            p_zp_conversion: "bcc2cfd4f5d12bf98243d0e8c936cadb",
	            p_zp_convinfo: res.id + ",100" //请使用真实的userid或邮箱、手机替换userId
	          });
	        }

	        that.regetCaptcha(0, 'clear');
	        that.getVoucher();
	      } else if (res && res.code == 10106) {
	        //手机已经存在
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { inputErrMsg: '手机已存在', ISCHKEC: 1 }),
	          btnText: '注册'
	        }));
	      } else if (res && res.code == 10105) {
	        //手机验证码错误
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { captchaErrMsg: '短信验证码错误' }),
	          btnText: '注册'
	        }));
	      } else if (res && res.code == 10102) {
	        //图像验证码错误
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { codeErrMsg: '验证码错误' }),
	          codeImg: that.props.userCenterApi + '/captcha?bg=' + Math.random(),
	          code: '',
	          btnText: '注册'
	        }));
	      } else {
	        that.setState((0, _objectAssign2.default)({}, that.state, {
	          errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { otherMsg: '注册失败，请重试' }),
	          btnText: '注册'
	        }));
	      }
	    }).catch(function (ex) {
	      console.log('parsing failed', ex); //eslint-disable-line no-console
	    });
	  },

	  //获取代金券
	  getVoucher: function getVoucher() {
	    var that = this;
	    var smartRedirect = location.href.split('#')[0];
	    var ss_user = (0, _componentCookie2.default)('ss_user');

	    fetch(this.props.card + '/activity?type=13&token=' + JSON.parse(ss_user).token).then(function (res) {
	      if (res.status == 200) {
	        return res.json();
	      }
	    }).then(function (res) {
	      if (res && res.code === 0) {
	        var uid = JSON.parse(ss_user).id;
	        (0, _componentCookie2.default)(uid + 'coupon', 2, { expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 10), path: '/' });
	        location.href = smartRedirect;
	      } else {
	        location.href = smartRedirect;
	      }
	    });
	  },

	  //验证邮箱
	  submitResigterEmail: function submitResigterEmail() {
	    var _state3 = this.state,
	        code = _state3.code,
	        password = _state3.password;

	    this.verifyAccountCheck(this.props.userCenterApi, 'email', this.state.email);
	    this.verifyPasswordCheck();
	    if (this.state.errMsg.ISCHKEC == 0 && this.state.errMsg.ISLENGTH == 1) {
	      if (!code) {
	        this.setState((0, _objectAssign2.default)({}, this.state, {
	          errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { codeErrMsg: '图形验证码不能为空' })
	        }));
	      } else if (!password) {
	        this.setState((0, _objectAssign2.default)({}, this.state, {
	          errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { psdErrMsg: '密码不能为空' })
	        }));
	      } else if (!this.state.checked) {
	        this.setState((0, _objectAssign2.default)({}, this.state, {
	          errMsg: (0, _objectAssign2.default)({}, this.state.errMsg, { otherMsg: '请选择用户用户协议' })
	        }));
	        return false;
	      } else {
	        this.setState({
	          btnText: ' 正在注册...',
	          time: 0
	        });
	        this.requestResigterEmail();
	      }
	    }
	  },

	  //邮箱注册接口
	  requestResigterEmail: function requestResigterEmail() {
	    var _state4 = this.state,
	        email = _state4.email,
	        password = _state4.password,
	        code = _state4.code;

	    var that = this;
	    (0, _fetchJsonp2.default)(this.props.userCenterApi + '/signup/email/jsonp?email=' + email.replace(/(^\s+)|(\s+$)/g, "") + '&password=' + password + '&captcha=' + code + '&source=' + this.props.source + '&from=' + this.props.from + '&group=' + this.props.group + '&detail=' + this.props.detail, {
	      jsonpCallback: 'smartCallback',
	      jsonpCallbackFunction: 'display',
	      credentials: 'include'
	    }).then(function (response) {
	      return response.json();
	    }).then(function (res) {
	      if (res && res.succeed) {
	        //晶赞
	        if (typeof window === 'undefined') return;
	        if (window && window.jing_zan_push) {
	          window.jing_zan_push({
	            pagetype: 'regSuccess',
	            p_zp_conversion: "bcc2cfd4f5d12bf98243d0e8c936cadb",
	            p_zp_convinfo: res.id + ",100" //请使用真实的userid或邮箱、手机替换userId
	          });
	        }
	        //发送激活邮件
	        that.activateEmail();
	      } else {
	        if (res.code == 10102) {
	          //邮件验证码错误
	          that.setState((0, _objectAssign2.default)({}, that.state, {
	            errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { codeErrMsg: '图形验证错误' }),
	            btnText: '注册'
	          }));
	        } else {
	          that.setState((0, _objectAssign2.default)({}, that.state, {
	            errMsg: (0, _objectAssign2.default)({}, that.state.errMsg, { otherMsg: '注册失败，请重试' }),
	            btnText: '注册'
	          }));
	        }
	      }
	    });
	  },

	  //发送邮箱激活邮件
	  activateEmail: function activateEmail() {
	    var _state5 = this.state,
	        email = _state5.email,
	        code = _state5.code;

	    var that = this;
	    var smartRedirect = location.href.split('#')[0];
	    fetch(this.props.userCenterApi + '/captcha/email', {
	      credentials: 'include',
	      method: 'post',
	      headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	      },
	      body: 'type=new&email=' + email + '&captcha=' + code + '&redirect=' + this.props.smart + '/confirm?smartRedirect=' + smartRedirect + '?from=new'
	    }).then(function (response) {
	      return response.json();
	    }).then(function (res) {
	      if (res.code != 0) {
	        location.href = that.props.smart + '/activateemail?smartRedirect=' + smartRedirect + '&email=' + email + '&from=new';
	      } else {
	        location.href = that.props.smart + '/activateemail?smartRedirect=' + smartRedirect + '&email=' + email + '&from=new';
	      }
	    });
	  }

	});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _config = __webpack_require__(3);

	var _config2 = _interopRequireDefault(_config);

	var _objectAssign = __webpack_require__(13);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* eslint-disable */
	var React = __webpack_require__(2);


	module.exports = React.createClass({
	  displayName: 'exports',

	  propTypes: {
	    userCenterApi: React.PropTypes.string,
	    user: React.PropTypes.shape({
	      email: React.PropTypes.string,
	      password: React.PropTypes.string,
	      code: React.PropTypes.string,
	      btnText: React.PropTypes.string,
	      errMsg: React.PropTypes.shape({
	        inputErrMsg: React.PropTypes.string,
	        psdErrMsg: React.PropTypes.string,
	        codeErrMsg: React.PropTypes.string,
	        ISCHKEC: React.PropTypes.number,
	        ISLENGTH: React.PropTypes.number
	      })
	    }),

	    loginState: React.PropTypes.func,
	    verifyPasswordCheck: React.PropTypes.func,
	    verifyAccountCheck: React.PropTypes.func,
	    openSignIn: React.PropTypes.func
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      userCenterApi: _config2.default.api.userCenterApi,
	      user: {
	        email: '',
	        password: '',
	        code: '',
	        errMsg: {
	          inputErrMsg: '',
	          psdErrMsg: '',
	          captchaErrMsg: '',
	          ISCHKEC: 2,
	          ISACTIVATE: 0
	        }
	      },

	      loginState: function loginState(state) {
	        console.log('loginState', state);
	      },

	      verifyPasswordCheck: function verifyPasswordCheck(state) {
	        console.log('verifyAccountCheck', state);
	      },
	      verifyAccountCheck: function verifyAccountCheck() {
	        console.log('verifyAccountCheck');
	      },
	      openSignIn: function openSignIn() {
	        console.log('openSignIn');
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      showPassword: 0,
	      email: '',
	      password: '',
	      errMsg: '',
	      time: '',
	      btnText: '',
	      codeImg: this.props.userCenterApi + '/captcha?bg=1',
	      emailCss: 0,
	      passwordCss: 0,
	      codeCss: 0,
	      checked: true
	    };
	  },

	  handleInputFun: function handleInputFun(name, num) {
	    var that = this;
	    if (name == 'email') {
	      that.state.emailCss != num && that.setState({
	        emailCss: num
	      });
	    } else if (name == 'password') {
	      that.state.passwordCss != num && that.setState({
	        passwordCss: num
	      });
	    } else if (name == 'code') {
	      that.state.codeCss != num && that.setState({
	        codeCss: num
	      });
	    }
	  },

	  handleInputFocus: function handleInputFocus(name, num) {
	    var psdErrMsg = this.psdErrMsg,
	        inputErrMsg = this.inputErrMsg,
	        codeErrMsg = this.codeErrMsg;

	    var that = this;
	    return function () {
	      if (name == 'email') {
	        var newState = (0, _objectAssign2.default)({}, that.props.user, {
	          errMsg: (0, _objectAssign2.default)({}, that.props.user.errMsg, {
	            inputErrMsg: '', ISCHKEC: 2
	          })
	        });
	      } else if (name == 'password') {
	        var newState = (0, _objectAssign2.default)({}, that.props.user, {
	          errMsg: (0, _objectAssign2.default)({}, that.props.user.errMsg, {
	            psdErrMsg: ''
	          })
	        });
	      } else if (name == 'code') {
	        var newState = (0, _objectAssign2.default)({}, that.props.user, {
	          errMsg: (0, _objectAssign2.default)({}, that.props.user.errMsg, {
	            codeErrMsg: ''
	          })
	        });
	      } else {
	        var newState = {};
	      }

	      that.props.loginState(newState);
	      that.handleInputFun(name, num);
	    };
	  },

	  handleInputChange: function handleInputChange(name, num) {
	    var that = this;
	    return function (event) {
	      var newState = {};
	      if (name == 'checked') {
	        newState[name] = event.target.checked;
	      } else {
	        newState[name] = event.target.value;
	      }
	      that.setState(newState);
	      that.props.loginState(newState);
	      that.handleInputFun(name, num);
	    };
	  },

	  verifyAccountCheck: function verifyAccountCheck(name, num) {
	    var that = this;
	    return function () {
	      that.props.verifyAccountCheck(that.props.userCenterApi, 'email', that.state.email);
	      that.handleInputFun(name, num);
	    };
	  },

	  verifyPasswordCheck: function verifyPasswordCheck(name, num) {
	    var that = this;
	    return function () {
	      that.props.verifyPasswordCheck(that.state.password);
	      that.handleInputFun(name, num);
	    };
	  },

	  handleInputClassName: function handleInputClassName(errName, stateName) {
	    var inputClass;
	    if (errName) {
	      inputClass = 'input-err';
	    } else {
	      if (stateName == 0) {
	        inputClass = 'user-input-info';
	      } else if (stateName == 1) {
	        inputClass = 'input-focus';
	      } else if (stateName == 2) {
	        inputClass = 'input-blur';
	      }
	    }
	    return inputClass;
	  },

	  render: function render() {
	    var _props$user = this.props.user,
	        email = _props$user.email,
	        password = _props$user.password,
	        code = _props$user.code;
	    var _props$user$errMsg = this.props.user.errMsg,
	        psdErrMsg = _props$user$errMsg.psdErrMsg,
	        inputErrMsg = _props$user$errMsg.inputErrMsg,
	        codeErrMsg = _props$user$errMsg.codeErrMsg,
	        ISCHKEC = _props$user$errMsg.ISCHKEC,
	        ISLENGTH = _props$user$errMsg.ISLENGTH;
	    var _state = this.state,
	        showPassword = _state.showPassword,
	        emailCss = _state.emailCss,
	        passwordCss = _state.passwordCss;


	    var psdInputClassName = this.handleInputClassName(psdErrMsg, this.state.passwordCss);
	    var userInputClassName = this.handleInputClassName(inputErrMsg, this.state.emailCss);
	    var codeClassName = this.handleInputClassName(codeErrMsg, this.state.codeCss);
	    var errInputInfo = null;

	    if (ISCHKEC == 1) {
	      errInputInfo = React.createElement(
	        'span',
	        { className: 'red' },
	        inputErrMsg
	      );
	    } else {
	      errInputInfo = React.createElement(
	        'div',
	        { className: 'err-msg', style: { display: inputErrMsg ? 'block' : 'none', right: '35px' } },
	        React.createElement(
	          'i',
	          null,
	          '!'
	        ),
	        React.createElement(
	          'span',
	          null,
	          inputErrMsg
	        )
	      );
	    }

	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { className: 'item account' },
	        React.createElement('input', {
	          type: 'text',
	          placeholder: '\u8BF7\u8F93\u5165\u90AE\u7BB1',
	          className: userInputClassName,
	          onChange: this.handleInputChange('email', 1),
	          onFocus: this.handleInputFocus('email', 1),
	          onBlur: this.verifyAccountCheck('email', 2),
	          value: email
	        }),
	        React.createElement('i', { className: email || emailCss ? 'user-icon-s' : 'user-icon-h' }),
	        errInputInfo,
	        React.createElement(
	          'a',
	          { href: 'javascript:;', className: 'go-submit-btn', style: { display: ISCHKEC == 1 ? 'block' : 'none' },
	            onClick: this.props.openSignIn },
	          '\u53BB\u767B\u5F55'
	        ),
	        React.createElement('span', { className: 'input-success', style: { display: ISCHKEC == 0 ? 'block' : 'none' } })
	      ),
	      React.createElement(
	        'div',
	        { className: 'item account' },
	        React.createElement('input', { name: 'password', type: showPassword ? 'text' : 'password',
	          placeholder: '\u81F3\u5C116\u4F4D\u4EFB\u610F\u5B57\u7B26\u7EC4\u5408',
	          className: psdInputClassName,
	          onChange: this.handleInputChange('password', 1),
	          onFocus: this.handleInputFocus('password', 1),
	          onBlur: this.verifyPasswordCheck('password', 2),
	          value: password }),
	        React.createElement('i', { className: password || passwordCss ? 'psd-icon-s' : 'psd-icon-h' }),
	        React.createElement('a', { className: showPassword ? 'password_h' : 'password_s', href: 'javascript:;', onClick: this.showPassword }),
	        React.createElement(
	          'div',
	          { className: 'err-msg', style: { display: psdErrMsg ? 'block' : 'none' } },
	          React.createElement(
	            'i',
	            null,
	            '!'
	          ),
	          React.createElement(
	            'span',
	            null,
	            psdErrMsg
	          )
	        ),
	        React.createElement('span', { className: 'input-success', style: { display: ISLENGTH ? 'block' : 'none' } })
	      ),
	      React.createElement(
	        'div',
	        { className: 'item code' },
	        React.createElement('input', { name: 'code', type: 'text', placeholder: '\u8BF7\u8F93\u5165\u56FE\u7247\u4E2D\u7684\u5185\u5BB9',
	          value: code,
	          className: codeClassName,
	          onChange: this.handleInputChange('code', 1),
	          onFocus: this.handleInputFocus('code', 1),
	          onBlur: this.verifyPasswordCheck('code', 2)
	        }),
	        React.createElement(
	          'span',
	          { className: 'get-code' },
	          React.createElement('img', { src: this.state.codeImg, alt: '\u9A8C\u8BC1\u7801', height: '20', align: 'bottom', title: '\u770B\u4E0D\u6E05\u53EF\u5355\u51FB\u56FE\u7247\u5237\u65B0',
	            onClick: this.getCode })
	        ),
	        React.createElement('b', { className: 'xuanzhuan', onClick: this.getCode }),
	        React.createElement(
	          'div',
	          { className: 'err-msg captcha-err-msg', style: { display: codeErrMsg ? 'block' : 'none' } },
	          React.createElement(
	            'i',
	            null,
	            '!'
	          ),
	          React.createElement(
	            'span',
	            null,
	            codeErrMsg
	          )
	        )
	      )
	    );
	  },

	  showPassword: function showPassword() {
	    var that = this;
	    this.setState({
	      showPassword: !that.state.showPassword
	    });
	  },

	  getCode: function getCode() {
	    this.setState({ codeImg: this.props.userCenterApi + '/captcha?bg=' + Math.random() });
	  }
	});
	/* eslint-enable */

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _config = __webpack_require__(3);

	var _config2 = _interopRequireDefault(_config);

	var _objectAssign = __webpack_require__(13);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* eslint-disable */
	var React = __webpack_require__(2);

	var SigUpPhoneCaptcha = __webpack_require__(24);

	module.exports = React.createClass({
	  displayName: 'exports',


	  propTypes: function propTypes() {
	    return {
	      userCenterApi: React.PropTypes.string,
	      user: React.PropTypes.shape({
	        phone: React.PropTypes.string,
	        password: React.PropTypes.string,
	        code: React.PropTypes.string,
	        time: React.PropTypes.number,
	        btnText: React.PropTypes.string,
	        errMsg: React.PropTypes.shape({
	          inputErrMsg: React.PropTypes.string,
	          psdErrMsg: React.PropTypes.string,
	          codeErrMsg: React.PropTypes.string,
	          captchaErrMsg: React.PropTypes.string,
	          ISCHKEC: React.PropTypes.number,
	          ISLENGTH: React.PropTypes.number
	        })
	      }),

	      loginState: React.PropTypes.func,
	      verifyAccountCheck: React.PropTypes.func,
	      verifyPasswordCheck: React.PropTypes.func,
	      openSignIn: React.PropTypes.func,
	      getCode: React.PropTypes.func,
	      getCaptcha: React.PropTypes.func
	    };
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      userCenterApi: _config2.default.api.userCenterApi,
	      user: {
	        phone: '',
	        password: '',
	        code: '',
	        time: 0,
	        errMsg: {
	          inputErrMsg: '',
	          psdErrMsg: '',
	          codeErrMsg: '',
	          captchaErrMsg: '',
	          ISCHKEC: 2,
	          ISACTIVATE: 0
	        }
	      },

	      loginState: function loginState(state) {
	        console.log('loginState', state);
	      },

	      verifyPasswordCheck: function verifyPasswordCheck(state) {
	        console.log('verifyPasswordCheck', state);
	      },

	      verifyAccountCheck: function verifyAccountCheck() {
	        console.log('verifyAccountCheck');
	      },

	      openSignIn: function openSignIn() {
	        console.log('openSignIn');
	      },

	      getCode: function getCode() {
	        console.log('getCode');
	      },
	      getCaptcha: function getCaptcha() {
	        console.log('getCaptcha¬');
	      }
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      showPassword: 0,
	      phone: '',
	      password: '',
	      code: '',
	      codeImg: this.props.userCenterApi + '/captcha?bg=1',
	      captcha: '',
	      errMsg: '',
	      time: '',
	      btnText: '',
	      captchText: '',
	      phoneCss: 0,
	      passwordCss: 0,
	      captchaCss: 0,
	      codeCss: 0,
	      checked: true
	    };
	  },

	  handleInputFun: function handleInputFun(name, num) {
	    var that = this;
	    if (name == 'phone') {
	      that.state.phoneCss != num && that.setState({
	        phoneCss: num
	      });
	    } else if (name == 'password') {
	      that.state.passwordCss != num && that.setState({
	        passwordCss: num
	      });
	    } else if (name == 'captcha') {
	      that.state.captchaCss != num && that.setState({
	        captchaCss: num
	      });
	    } else if (name == 'code') {
	      that.state.codeCss != num && that.setState({
	        codeCss: num
	      });
	    }
	  },

	  handleInputChange: function handleInputChange(name, num) {
	    var that = this;
	    return function (event) {
	      var newState = {};
	      if (name == 'checked') {
	        newState[name] = event.target.checked;
	      } else {
	        newState[name] = event.target.value;
	      }
	      that.setState(newState);
	      that.props.loginState(newState);
	      that.handleInputFun(name, num);
	    };
	  },

	  handleInputFocus: function handleInputFocus(name, num) {
	    var psdErrMsg = this.psdErrMsg,
	        inputErrMsg = this.inputErrMsg,
	        codeErrMsg = this.codeErrMsg;

	    var that = this;
	    return function () {
	      if (name == 'phone') {
	        var newState = (0, _objectAssign2.default)({}, that.props.user, {
	          errMsg: (0, _objectAssign2.default)({}, that.props.user.errMsg, {
	            inputErrMsg: '', ISCHKEC: 2
	          })
	        });
	      } else if (name == 'password') {
	        var newState = (0, _objectAssign2.default)({}, that.props.user, {
	          errMsg: (0, _objectAssign2.default)({}, that.props.user.errMsg, {
	            psdErrMsg: ''
	          })
	        });
	      } else if (name == 'code') {
	        var newState = (0, _objectAssign2.default)({}, that.props.user, {
	          errMsg: (0, _objectAssign2.default)({}, that.props.user.errMsg, {
	            codeErrMsg: ''
	          })
	        });
	      } else if (name == 'captcha') {
	        var newState = (0, _objectAssign2.default)({}, that.props.user, {
	          errMsg: (0, _objectAssign2.default)({}, that.props.user.errMsg, {
	            captchaErrMsg: ''
	          })
	        });
	      } else {
	        var newState = {};
	      }

	      that.props.loginState(newState);
	      that.handleInputFun(name, num);
	    };
	  },

	  verifyAccountCheck: function verifyAccountCheck(name, num) {
	    var that = this;
	    return function () {
	      that.props.verifyAccountCheck(that.props.userCenterApi, 'phone', that.state.phone);
	      that.handleInputFun(name, num);
	    };
	  },

	  verifyPasswordCheck: function verifyPasswordCheck(name, num) {
	    var that = this;
	    return function () {
	      that.props.verifyPasswordCheck(that.state.password);
	      that.handleInputFun(name, num);
	    };
	  },

	  handleInputClassName: function handleInputClassName(errName, stateName) {
	    var inputClass;
	    if (errName) {
	      inputClass = 'input-err';
	    } else {
	      if (stateName == 0) {
	        inputClass = 'user-input-info';
	      } else if (stateName == 1) {
	        inputClass = 'input-focus';
	      } else if (stateName == 2) {
	        inputClass = 'input-blur';
	      }
	    }
	    return inputClass;
	  },

	  render: function render() {

	    if (this.props.user.time && this.props.user.time > 0) {
	      var captchaText = '等待' + this.props.user.time;
	      var captchaCn = 'get-captcha get-captcha-checked';
	    } else if (this.props.user.time && this.state.user.captchText) {
	      var captchaText = this.state.captchText;
	      var captchaCn = 'get-captcha get-captcha-checked';
	    } else {
	      var captchaText = '免费获取短信';
	      var captchaCn = this.props.user.phone ? 'get-captcha' : 'get-captcha get-captcha-checked';
	    }
	    var _props$user = this.props.user,
	        phone = _props$user.phone,
	        password = _props$user.password,
	        code = _props$user.code,
	        captcha = _props$user.captcha;
	    var _props$user$errMsg = this.props.user.errMsg,
	        psdErrMsg = _props$user$errMsg.psdErrMsg,
	        inputErrMsg = _props$user$errMsg.inputErrMsg,
	        captchaErrMsg = _props$user$errMsg.captchaErrMsg,
	        codeErrMsg = _props$user$errMsg.codeErrMsg,
	        ISCHKEC = _props$user$errMsg.ISCHKEC,
	        ISLENGTH = _props$user$errMsg.ISLENGTH;
	    var _state = this.state,
	        showPassword = _state.showPassword,
	        phoneCss = _state.phoneCss,
	        passwordCss = _state.passwordCss;

	    var passwordCn = showPassword ? 'password_h' : 'password_s';
	    var passwordType = showPassword ? 'text' : 'password';

	    var psdInputClassName = this.handleInputClassName(psdErrMsg, this.state.passwordCss);
	    var userInputClassName = this.handleInputClassName(inputErrMsg, this.state.phoneCss);
	    var captchaClassName = this.handleInputClassName(captchaErrMsg, this.state.captchaCss);
	    var codeClassName = this.handleInputClassName(codeErrMsg, this.state.codeCss);

	    var errInputInfo = null;
	    if (ISCHKEC == 1) {
	      var errInputInfo = React.createElement(
	        'span',
	        { className: 'red' },
	        inputErrMsg
	      );
	    } else {
	      var errInputInfo = React.createElement(
	        'div',
	        { className: 'err-msg', style: { display: inputErrMsg ? 'block' : 'none', right: '35px' } },
	        React.createElement(
	          'i',
	          null,
	          '!'
	        ),
	        React.createElement(
	          'span',
	          null,
	          inputErrMsg
	        )
	      );
	    }
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { className: 'item account' },
	        React.createElement('input', {
	          type: 'text',
	          className: userInputClassName,
	          placeholder: '\u8BF7\u586B\u5199\u624B\u673A\u53F7\u7801',
	          value: phone,
	          onChange: this.handleInputChange('phone', 1),
	          onFocus: this.handleInputFocus('phone', 1),
	          onBlur: this.verifyAccountCheck('phone', 2)
	        }),
	        React.createElement('i', { className: phone || phoneCss ? 'user-icon-s' : 'user-icon-h' }),
	        errInputInfo,
	        React.createElement(
	          'a',
	          { href: 'javascript:;', className: 'go-submit-btn', style: { display: ISCHKEC == 1 ? 'block' : 'none' },
	            onClick: this.props.openSignIn },
	          '\u53BB\u767B\u5F55'
	        ),
	        React.createElement('span', { className: 'input-success', style: { display: ISCHKEC == 0 ? 'block' : 'none' } })
	      ),
	      React.createElement(
	        'div',
	        { className: 'item account' },
	        React.createElement('input', { name: 'password', type: passwordType,
	          placeholder: '\u81F3\u5C116\u4F4D\u4EFB\u610F\u5B57\u7B26\u7EC4\u5408',
	          className: psdInputClassName,
	          onChange: this.handleInputChange('password', 1),
	          onFocus: this.handleInputFocus('password', 1),
	          onBlur: this.verifyPasswordCheck('password', 2),
	          value: password }),
	        React.createElement('i', { className: password || passwordCss ? 'psd-icon-s' : 'psd-icon-h' }),
	        React.createElement('a', { className: passwordCn, href: 'javascript:;', onClick: this.showPassword }),
	        React.createElement(
	          'div',
	          { className: 'err-msg', style: { display: psdErrMsg ? 'block' : 'none' } },
	          React.createElement(
	            'i',
	            null,
	            '!'
	          ),
	          React.createElement(
	            'span',
	            null,
	            psdErrMsg
	          )
	        ),
	        React.createElement('span', { className: 'input-success', style: { display: ISLENGTH ? 'block' : 'none' } })
	      ),
	      React.createElement(SigUpPhoneCaptcha, {
	        handleInputChange: this.handleInputChange,
	        handleInputFocus: this.handleInputFocus,
	        verifyPasswordCheck: this.verifyPasswordCheck,
	        codeClassName: codeClassName,
	        user: this.props.user,
	        getCode: this.props.getCode,
	        codeErrMsg: codeErrMsg
	      }),
	      React.createElement(
	        'div',
	        { className: 'item captcha' },
	        React.createElement('input', { name: 'captcha', type: 'text', placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801',
	          style: { paddingLeft: '20px' },
	          className: captchaClassName,
	          onChange: this.handleInputChange('captcha', 1),
	          onFocus: this.handleInputFocus('captcha', 1),
	          onBlur: this.verifyPasswordCheck('captcha', 2),
	          value: captcha
	        }),
	        React.createElement(
	          'span',
	          { className: captchaCn, onClick: this.props.getCaptcha },
	          captchaText
	        ),
	        React.createElement(
	          'div',
	          { className: 'err-msg code-err-msg', style: { display: captchaErrMsg ? 'block' : 'none' } },
	          React.createElement(
	            'i',
	            null,
	            '!'
	          ),
	          React.createElement(
	            'span',
	            null,
	            captchaErrMsg
	          )
	        )
	      )
	    );
	  },

	  showPassword: function showPassword() {
	    var that = this;
	    this.setState({
	      showPassword: !that.state.showPassword
	    });
	  }

	});
	/* eslint-enable */

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _config = __webpack_require__(3);

	var _config2 = _interopRequireDefault(_config);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Created by xieshanshan on 16/7/26.
	 *  弹窗注册手机 页面注册手机 图形验证码的展示
	 */

	var React = __webpack_require__(2);


	module.exports = React.createClass({
	  displayName: 'exports',

	  propTypes: function propTypes() {
	    return {
	      user: React.PropTypes.shape({
	        code: React.PropTypes.string,
	        errMsg: React.PropTypes.shape({
	          codeErrMsg: React.PropTypes.string
	        }),
	        codeImg: React.PropTypes.string
	      }),
	      handleInputChange: React.PropTypes.func,
	      handleInputFocus: React.PropTypes.func,
	      verifyPasswordCheck: React.PropTypes.func,
	      codeClassName: React.PropTypes.string,
	      getCode: React.PropTypes.func
	    };
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      user: {
	        code: '',
	        codeImg: _config2.default.api.userCenterApi + '/captcha?bg=1',
	        errMsg: {
	          codeErrMsg: ''
	        }
	      },
	      handleInputChange: function handleInputChange() {
	        console.log('handleInputChange');
	      },
	      handleInputFocus: function handleInputFocus() {
	        console.log('handleInputFocus');
	      },
	      verifyPasswordCheck: function verifyPasswordCheck() {
	        console.log('verifyPasswordCheck');
	      },
	      getCode: function getCode() {
	        console.log('getCode');
	      },
	      codeClassName: 'user-input-info'
	    };
	  },

	  handleCaptchaContent: function handleCaptchaContent() {
	    var _props$user = this.props.user,
	        code = _props$user.code,
	        codeErrMsg = _props$user.errMsg.codeErrMsg,
	        codeImg = _props$user.codeImg;

	    return React.createElement(
	      'div',
	      { className: 'item code source-signin' },
	      React.createElement('input', { name: 'code', type: 'text', placeholder: '\u586B\u5199\u9A8C\u8BC1\u7801',
	        style: { paddingLeft: '20px' },
	        onChange: this.props.handleInputChange('code', 1),
	        onFocus: this.props.handleInputFocus('code', 1),
	        onBlur: this.props.verifyPasswordCheck('code', 2),
	        className: this.props.codeClassName,
	        value: code }),
	      React.createElement(
	        'span',
	        { className: 'get-code' },
	        React.createElement('img', { src: codeImg, alt: '\u9A8C\u8BC1\u7801', height: '20', align: 'bottom', title: '\u770B\u4E0D\u6E05\u53EF\u5355\u51FB\u56FE\u7247\u5237\u65B0',
	          onClick: this.props.getCode })
	      ),
	      React.createElement('b', { className: 'xuanzhuan', onClick: this.props.getCode }),
	      React.createElement(
	        'div',
	        { className: 'err-msg captcha-err-msg', style: { display: codeErrMsg ? 'block' : 'none' } },
	        React.createElement(
	          'i',
	          null,
	          '!'
	        ),
	        React.createElement(
	          'span',
	          null,
	          codeErrMsg
	        )
	      )
	    );
	  },

	  render: function render() {
	    return this.handleCaptchaContent();
	  }
	});

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	/**
	 * Created by xieshanshan on 16/7/27.
	 * 用户协议组件
	 */
	var React = __webpack_require__(2);
	module.exports = React.createClass({
	  displayName: 'exports',

	  propTypes: function propTypes() {
	    return {
	      loginState: React.PropTypes.func
	    };
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      loginState: function loginState(state) {
	        console.log('loginState');
	      }
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      checked: true
	    };
	  },

	  render: function render() {
	    //userdeal
	    return React.createElement(
	      'div',
	      { className: 'other' },
	      React.createElement(
	        'span',
	        { className: 'checkbox' },
	        React.createElement('input', {
	          type: 'checkbox',
	          onChange: this.handleInputChange('checked'),
	          checked: this.state.checked }),
	        React.createElement(
	          'a',
	          { className: 'a_checked', href: 'javascript:;', onClick: this.changeCheckbox },
	          '\u6211\u5DF2\u9605\u8BFB\u5E76\u63A5\u53D7'
	        ),
	        React.createElement(
	          'a',
	          { href: this.props.smart + '/info/service.html', target: '_blank' },
	          React.createElement(
	            'b',
	            { className: 'xieyi' },
	            '\u300A\u667A\u8BFE\u7528\u6237\u6CE8\u518C\u534F\u8BAE\u300B'
	          )
	        )
	      )
	    );
	  },

	  handleInputChange: function handleInputChange(name) {
	    var that = this;
	    return function (event) {
	      var newState = {};
	      newState[name] = event.target.checked;
	      that.setState(newState);
	      that.props.loginState(newState);
	    };
	  },

	  changeCheckbox: function changeCheckbox() {
	    this.setState({
	      checked: !this.state.checked
	    });

	    this.props.loginState({
	      checked: !this.state.checked
	    });
	  }
	});
	/* eslint-enable */

/***/ })
/******/ ]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/_smart-login-new@1.0.3@smart-login-new/dist/smartlogin.js
 ** module id = 524
 ** module chunks = 0
 **/